import type { Dict } from './index.js';

export const pt: Dict = {
  'app.name': 'RPG Desk',
  'app.tagline': 'Tudo o que você precisa para jogar.',

  'login.welcome': 'Que bom te ver de novo!',
  'login.account': 'Conta ou e-mail',
  'login.password': 'Senha',
  'login.showPassword': 'Mostrar senha',
  'login.hidePassword': 'Ocultar senha',
  'login.keepSignedIn': 'Manter conectado',
  'login.submit': 'Entrar',
  'login.forgotPassword': 'Esqueci a senha',
  'login.register': 'Ainda não tem conta? Crie uma agora',
  'login.error.accountRequired': 'Informe sua conta ou e-mail',
  'login.error.passwordRequired': 'Informe sua senha',
  'login.error.failed': 'Não foi possível entrar',
  'login.connectionProblem': 'Problema de conexão',

  'register.cancel': 'Já tenho conta: voltar ao login',
  'register.welcome': 'Vamos criar sua conta',
  'register.email': 'E-mail',
  'register.account': 'Nome da conta',
  'register.gender': 'Como devemos nos referir a você?',
  'register.gender.masculine': 'No masculino (ele)',
  'register.gender.feminine': 'No feminino (ela)',
  'register.gender.neutral': 'De forma neutra',
  'register.continue': 'Continuar',
  'register.step2.welcome': 'Escolha uma senha',
  'register.password': 'Senha',
  'register.confirmPassword': 'Repita a senha',
  'register.wantPromoMail': 'Quero receber novidades por e-mail',
  'register.acceptTos': 'Tenho {age} anos ou mais e aceito os {terms} e a {privacy}',
  'register.submit': 'Criar conta',
  'register.back': 'Voltar',

  'register.error.required': 'Campo obrigatório',
  'register.error.tooShort': 'Muito curto (mínimo de 3 caracteres)',
  'register.error.tooLong': 'Muito longo (máximo de 24 caracteres)',
  'register.error.invalid.displayName': 'Use letras, números, espaço, ponto, hífen ou sublinhado',
  'register.error.invalid.email': 'E-mail inválido',
  'register.error.taken.displayName': 'Esse nome já está em uso',
  'register.error.taken.email': 'Esse e-mail já está cadastrado',
  'register.error.gender': 'Escolha uma opção',
  'register.error.passwordEmpty': 'Escolha uma senha',
  'register.error.passwordMismatch': 'As senhas não conferem',
  'register.error.tosRequired': 'Confirme a idade e aceite os termos para continuar',
  'register.error.failed': 'Não foi possível criar a conta',

  'forgot.title': 'Recuperar senha',
  'forgot.text': 'A recuperação por e-mail ainda não está disponível neste servidor. Peça ao administrador para redefinir sua senha.',

  // a confirmação do e-mail (docs/spec/email.md): a tela de espera e o link
  'confirmEmail.title': 'Confirme seu e-mail',
  'confirmEmail.sent': 'Mandamos um link para {email}.',
  'confirmEmail.open': 'Abra o e-mail e clique em Confirmar e-mail. O link vale por {hours} horas.',
  'confirmEmail.failed': 'Não conseguimos mandar o e-mail para {email}. Tente reenviar.',
  'confirmEmail.resend': 'Reenviar e-mail',
  'confirmEmail.resendIn': 'Reenviar em {time}',
  'confirmEmail.resent': 'Mandamos outro link. Confira também o spam.',
  'confirmEmail.wrong': 'O e-mail está errado?',
  'confirmEmail.deleteAt': 'Sem a confirmação, a conta é apagada em {date}.',
  'confirmEmail.change.text': 'Escreva o e-mail certo. O link vai para ele.',
  'confirmEmail.change.submit': 'Mandar para este e-mail',
  'confirmEmail.change.cancel': 'Voltar',
  'confirmEmail.logout': 'Sair da conta',
  'confirmEmail.link.confirmed.title': 'E-mail confirmado',
  'confirmEmail.link.confirmed': 'Tudo certo. Entre na sua conta para começar.',
  'confirmEmail.link.expired.title': 'Link vencido',
  'confirmEmail.link.expired': 'Este link de confirmação venceu. Entre na sua conta e peça outro.',
  'confirmEmail.link.invalid.title': 'Link sem valor',
  'confirmEmail.link.invalid': 'Este link de confirmação não vale mais: já foi usado, ou um mais novo foi enviado. Entre na sua conta para continuar.',
  'confirmEmail.link.failed.title': 'Não deu para confirmar',
  'confirmEmail.link.failed': 'Não deu para confirmar o e-mail agora. Confira a conexão e abra o link de novo.',
  'confirmEmail.toast.confirmed': 'E-mail confirmado. Boas-vindas ao RPG Desk!',
  'confirmEmail.toast.expired': 'Este link de confirmação venceu. Peça outro.',
  'confirmEmail.toast.invalid': 'Este link de confirmação não vale mais.',
  'confirmEmail.toast.failed': 'Não deu para confirmar o e-mail agora. Abra o link de novo.',

  'legal.terms.title': 'Termos de Uso',
  'legal.privacy.title': 'Política de Privacidade',
  'legal.terms.short': 'Termos de uso',
  'legal.privacy.short': 'Privacidade',
  'legal.nav': 'Termos e privacidade',
  'legal.toc': 'Nesta página',
  'legal.meta': 'Versão {version} · Atualizada em {date}',
  'legal.loading': 'Carregando…',
  'legal.error': 'Não foi possível abrir o texto. Confira a conexão e tente de novo.',
  'legal.back': 'Voltar ao RPG Desk',
  'legal.update.title': 'Os termos mudaram',
  'legal.update.text':
    'Os Termos de Uso e a Política de Privacidade do RPG Desk foram atualizados em {date}. Para continuar usando a sua conta, leia e aceite a nova versão.',
  'legal.update.accept': 'Aceitar e continuar',
  'legal.update.signOut': 'Sair da conta',

  'logged.nav.label': 'Navegação principal',
  'logged.nav.dashboard': 'Início',
  'logged.nav.rooms': 'Salas',
  'logged.nav.friends': 'Amigos',
  'logged.nav.cloud': 'Desk Cloud',
  'logged.nav.settings': 'Configurações',
  'logged.nav.logout': 'Sair',
  'logged.nav.more': 'Mais',
  'logged.nav.openRooms': 'Salas abertas',
  'logged.nav.room': 'Sala',
  'logged.rooms.leave': 'Sair da mesa',
  'logged.rooms.back': 'Voltar à mesa {name}',
  'logged.rooms.tooMany': 'Já há {max} mesas abertas: saia de uma (clique direito no botão dela) para abrir outra',
  'logged.rooms.unread': '{count} não lidas',
  'logged.rooms.mention': 'menção',
  'logged.rooms.clock.running': 'sessão {n} em andamento, {played} de jogo',
  'logged.rooms.clock.paused': 'sessão {n} em pausa, {played} de jogo',

  'room.entering': 'Entrando na sala…',
  'room.people': '{n} na sala',
  'room.status.online': 'Conectado',
  'room.status.connecting': 'Conectando…',
  'room.status.offline': 'Desconectado',
  'room.voice': 'Voz e vídeo',
  'room.voice.inCall': 'Na conferência (voz e vídeo)',
  'room.voice.on': 'Na conferência',
  'room.leave': 'Sair da mesa',
  'room.closeModule': 'Fechar',
  // a mesa no celular (docs/spec/mobile.md)
  'room.mobile.back': 'Voltar',
  'room.mobile.tabs': 'Abas da mesa',
  'room.mobile.tab.chat': 'Chat',
  'room.mobile.tab.scene': 'Cena',
  'room.mobile.tab.sheets': 'Fichas',
  'room.mobile.tab.people': 'Pessoas',
  'room.mobile.tab.more': 'Mais',
  'room.mobile.newChat': 'Nova conversa',
  'room.mobile.chatWith': 'Conversar com {name}',
  'room.mobile.openOther': 'Abrir outra',
  'room.mobile.scenes.pick': 'Escolha uma cena',
  'room.mobile.scenes.empty': 'A mesa ainda não tem cenas que você possa ver.',
  'room.mobile.sheets.pick': 'Escolha uma ficha',
  'room.mobile.sheets.empty': 'A mesa ainda não tem fichas que você possa ver.',

  'module.mainChat': 'Chat',
  'module.userList': 'Participantes',
  'module.library': 'Biblioteca',
  'module.scene': 'Cena',
  'module.music': 'Música',
  'module.sfx': 'Efeitos sonoros',
  'module.files': 'Arquivos',
  'module.gameSessions': 'Sessões',
  'module.tableDock': 'Painel de mesa',
  'module.roomSettings': 'Configurações da mesa',

  'chat.tools': 'Ferramentas do chat',
  'chat.sendButton': 'Enviar',
  'chat.tool.format': 'Formatação e falar como',
  'chat.tool.bold': 'Negrito',
  'chat.tool.italic': 'Itálico',
  'chat.tool.underline': 'Sublinhado',
  'chat.tool.color': 'Cor do texto',
  'chat.tool.dice': 'Rolar 1d{n}',
  'chat.persona': 'Falar como',
  'chat.persona.none': 'Eu mesmo',
  'chat.persona.narrator': 'Narrador',
  'chat.persona.npc': 'NPC…',
  'chat.persona.npcName': 'Nome do NPC',
  'chat.input.prompt': 'Digite uma mensagem…',
  'chat.input.send': 'Enviar',
  'chat.rolled': 'rolou',
  'chat.rolling': 'rolando…',

  'dice.failure': 'Falha',
  'dice.criticalFailure': 'Falha crítica',
  'dice.oneSuccess': '1 sucesso',
  'dice.nSuccesses': '{n} sucessos',
  'dice.dropped': 'Ficou de fora da soma',
  'dice.error.empty': 'A rolagem está vazia.',
  'dice.error.unknownChar': 'A rolagem tem um caractere que não vale: "{detail}".',
  'dice.error.missingFace': 'Faltou o número de faces do dado (d20, d8, d6…).',
  'dice.error.unknownRoll': 'Essa rolagem de dados não existe (um "d" a mais?).',
  'dice.error.unknownOperator': 'Operador desconhecido na rolagem.',
  'dice.error.unknownComparator': 'Comparador desconhecido: "{detail}". Use > para contar sucessos.',
  'dice.error.maxOneComparator': 'A rolagem só pode ter um comparador (>).',
  'dice.error.minOneDie': 'A rolagem precisa de pelo menos um dado.',
  'dice.error.flood': 'Rolagem grande demais: até 300 entre dados e números.',
  'dice.error.bigNumber': 'Número grande demais na rolagem: até 1.000.000.',
  'dice.error.tooLong': 'A rolagem passou de {max} caracteres, com o texto depois do ":".',
  'error.noSession': 'sem sessão',
  'error.badImage': 'imagem inválida',
  'error.imageSlow': 'a imagem demorou demais para carregar',
  'error.imageLoad': 'não foi possível carregar a imagem',
  'scene.uvtt.notJson': 'o arquivo não é JSON',
  'scene.uvtt.noSize': 'o arquivo não tem o tamanho do mapa (resolution.map_size) válido',
  'scene.uvtt.noImage': 'o arquivo não traz a imagem do mapa',
  'scene.uvtt.badImage': 'a imagem do mapa não é PNG, WebP nem JPEG',
  'api.unreachable': 'não foi possível falar com o servidor (ele está rodando?)',
  'api.unexpected': 'erro inesperado',
  'api.status': 'erro {status}',
  'api.uploadFailed': 'falha no envio (HTTP {status})',
  'api.uploadCanceled': 'envio cancelado',
  'api.noAnswer': 'o servidor não respondeu',
  'dice.error.timeout': 'A rolagem não voltou do servidor.',

  'users.group.gms': 'Mestre',
  'users.group.players': 'Jogador',
  'users.online': 'Conectado',
  'users.you': 'você',

  'room.menu': 'Menu da mesa',
  'room.panels.out': 'Está numa janela própria: clique para trazê-la para a frente.',
  'room.tabs': 'Abas',
  'room.tabs.hint': 'Abrir e fechar as abas e organizar a tela',
  'room.panelMenu': 'Mais ações do espaço',
  'room.closePanel': 'Fechar o espaço',
  'room.panel.collapse': 'Recolher',
  'room.panel.maximize': 'Ampliar',
  'room.panel.restore': 'Restaurar',
  'room.panel.expand': 'Mostrar',
  'room.panel.empty': 'Abra uma cena ou ficha pela biblioteca, ou arraste uma aba para cá.',
  'room.panel.empty.window': 'Abra uma aba aqui pelo +, ou traga uma da mesa (botão direito na aba → Mover para).',
  'room.panel.emptyLabel': 'Espaço vazio',
  'room.panel.new': 'Espaço novo ao lado',
  'room.tab.add': 'Abrir uma aba aqui',
  'room.tab.add.elsewhere': 'Está em outro espaço: vem para cá',
  'room.tab.add.chatCopy': 'O chat da mesa fica lá, e vem uma cópia',
  'room.tab.moveTo': 'Mover para',
  'room.tab.moveInto': 'Junto de {name}',
  'room.group.chats.fixed': 'O chat da mesa não fecha.',
  'room.move': 'Mover para',
  'room.move.left': 'Esquerda',
  'room.move.center': 'Centro',
  'room.move.right': 'Direita',
  'room.move.table': 'Mover para a mesa',
  'room.where.here': 'Nesta janela',
  'room.where.table': 'Na mesa',
  'room.where.otherWindow': 'Noutra janela',
  'room.window.new': 'Nova janela',
  'room.leave.confirm.title': 'Sair da mesa?',
  'room.leave.confirm.message': 'Você sai de {name}. Para voltar, entre de novo pelo Início ou por Salas.',
  'room.layout.edit': 'Organizar a tela',
  'room.layout.done': 'Concluir organização',
  'room.layout.banner': 'Organizando a tela: arraste uma aba, ou um espaço inteiro pela parte vazia da faixa de abas, até a borda de outro espaço ou da mesa. Com Ctrl ou Alt apertado ao soltar, fica uma cópia da aba. O + põe uma aba naquele lugar. Ctrl+E ou Esc sai.',
  'room.layout.banner.window': 'Organizando a janela: arraste uma aba, ou um espaço inteiro pela parte vazia da faixa de abas, até a borda de outro espaço ou da janela. Com Ctrl ou Alt apertado ao soltar, fica uma cópia da aba. O + põe uma aba naquele lugar. Ctrl+E ou Esc sai.',
  'room.layout.banner.narrow': 'Numa janela estreita, as abas ficam todas juntas. Alargue a janela para organizar a tela.',
  'room.layout.reset': 'Voltar ao arranjo inicial',
  'room.layout.reset.message': 'As abas desta mesa voltam ao arranjo inicial: a biblioteca à esquerda, um espaço vazio e o chat no meio, e os participantes à direita.',
  'room.layout.reset.action': 'Voltar ao arranjo inicial',
  'room.layout.clone': 'Duplicar',
  'room.layout.dragHint': 'Arraste para levar o espaço inteiro, com as abas',
  'room.layout.add.title': 'Pôr aqui',
  'room.layout.add.left': 'Pôr uma aba à esquerda deste espaço',
  'room.layout.add.right': 'Pôr uma aba à direita deste espaço',
  'room.layout.add.top': 'Pôr uma aba em cima deste espaço',
  'room.layout.add.bottom': 'Pôr uma aba embaixo deste espaço',
  'room.layout.add.center': 'Pôr uma aba no centro',
  'room.layout.edge.left': 'Nova coluna à esquerda da mesa',
  'room.layout.edge.right': 'Nova coluna à direita da mesa',
  'room.layout.edge.top': 'Nova faixa no alto da mesa',
  'room.layout.edge.bottom': 'Nova faixa embaixo da mesa',
  'room.layout.edge.window.left': 'Dividir a janela: uma aba à esquerda',
  'room.layout.edge.window.right': 'Dividir a janela: uma aba à direita',
  'room.layout.edge.window.top': 'Dividir a janela: uma aba em cima',
  'room.layout.edge.window.bottom': 'Dividir a janela: uma aba embaixo',
  'room.layout.emptyCenter': 'O centro da mesa está vazio: arraste uma aba, ou um espaço, para cá.',
  'room.layout.emptyCenter.editing': 'Arraste uma aba ou um espaço para cá, ou use o +.',
  'chat.joined': 'entrou',
  'chat.left': 'saiu',
  'chat.tool.diceBar': 'Dados rápidos',
  'library.search': 'Procurar na biblioteca',
  'library.newFolder': 'Nova pasta',
  'library.folder': 'Pasta',
  'library.empty': 'A biblioteca está vazia.',

  'users.group.gm.one': 'Mestre',
  'users.group.gm.many': 'Mestres',
  'users.group.player.one': 'Jogador',
  'users.group.player.many': 'Jogadores',
  'users.group.spectator.one': 'Espectador',
  'users.group.spectator.many': 'Espectadores',
  'users.menu': 'Ações para {name}',
  'users.menu.profile': 'Ver perfil',
  'users.menu.photo': 'Ver foto',
  'users.menu.toGm': 'Tornar mestre',
  'users.menu.toPlayer': 'Tornar jogador',
  'users.menu.toSpectator': 'Tornar espectador',
  'users.menu.mute': 'Silenciar',
  'users.menu.unmute': 'Deixar falar',
  'users.menu.blind': 'Esconder o chat dele',
  'users.menu.unblind': 'Mostrar o chat de novo',
  'users.menu.voice': 'Pode falar no chat moderado',
  'users.menu.unvoice': 'Não pode falar no chat moderado',
  'users.menu.kick': 'Expulsar',
  'users.menu.ban': 'Banir',
  'users.menu.ban.confirm': 'Banir {name}? A conta não poderá voltar a esta sala até ser desbanida.',
  'users.menu.nick': 'Mudar meu apelido',
  'users.menu.nick.prompt': 'Apelido nesta sala (vazio volta ao nome da conta)',
  'users.mode.mute': 'silenciado',
  'users.mode.blind': 'sem ver o chat',
  'users.mode.voice': 'com voz',
  'users.typing': 'digitando…',
  'mode.gm': 'mestre',
  'mode.player': 'jogador',
  'mode.mute': 'silêncio',
  'mode.blind': 'cegueira',
  'mode.voice': 'voz',
  'mode.juggernaut': 'juggernaut',
  'chat.event.modes.added': 'deu {modes} a {target}',
  'chat.event.modes.removed': 'tirou {modes} de {target}',
  'chat.event.nick': 'agora se chama {to}',
  'chat.event.kick': 'expulsou {target}',
  'chat.event.ban': 'baniu {target}',
  'chat.event.moderated.on': 'ligou o chat moderado',
  'chat.event.moderated.off': 'desligou o chat moderado',
  'chat.typing.one': '{a} está digitando…',
  'chat.typing.two': '{a} e {b} estão digitando…',
  'chat.typing.many': 'Várias pessoas estão digitando…',
  'chat.moderatedBanner': 'O chat está moderado: só mestres e quem tem voz falam.',
  'chat.moderated.end': 'Encerrar',
  'chat.delete.label': 'Apagar a mensagem de {name}',
  'chat.delete.roll.label': 'Apagar a rolagem de {name}',
  'chat.delete.hint': 'Apagar (Shift+clique apaga sem perguntar)',
  'chat.delete.title': 'Apagar a mensagem de {name}?',
  'chat.delete.roll.title': 'Apagar a rolagem de {name}?',
  'chat.delete.message': 'Ela some do chat de todos. Os mestres ainda a veem com /audit.',
  'chat.delete.action': 'Apagar',
  'chat.delete.offline': 'Sem conexão: nada foi apagado.',
  'chat.delete.menu': 'Apagar mensagem…',
  'chat.delete.roll.menu': 'Apagar rolagem…',
  'chat.line.message': 'Mensagem de {name}',
  'chat.line.roll': 'Rolagem de {name}',
  'chat.line.copy': 'Copiar o texto',
  'chat.line.copied': 'Texto copiado.',
  'chat.line.copyFailed': 'Não deu para copiar o texto.',
  'chat.clear': 'Limpar o chat…',
  'chat.clear.title': 'Limpar o chat da mesa?',
  'chat.clear.message': 'Todas as mensagens, rolagens e linhas do sistema somem do chat de todos. Os mestres ainda as veem com /audit. As conversas privadas não mudam.',
  'chat.clear.action': 'Limpar',
  'chat.audit.banner': 'Modo de auditoria: as mensagens apagadas aparecem marcadas.',
  'chat.audit.exit': 'Fechar',
  'chat.audit.exit.label': 'Fechar o modo de auditoria',
  'chat.deleted.mark': '(apagada)',
  'chat.deleted.by': 'Apagada por {name} em {when}',
  'chat.deleted.byClear': 'Apagada por {name} ao limpar o chat, em {when}',
  'room.moderate.on': 'Moderar o chat',
  'room.moderate.off': 'Encerrar moderação do chat',
  'room.removed.kicked': '{by} tirou você da sala.',
  'room.removed.banned': '{by} baniu você desta sala.',

  'explore.nav': 'Mostrar',
  'explore.tab.online': 'Com gente agora',
  'explore.only.new': 'Só as que não conheço',
  'explore.newRoom': 'Nova mesa',
  'explore.empty.hint.recent': 'As mesas em que você entrar aparecem aqui.',
  'explore.empty.hint.favorites': 'Clique com o botão direito numa mesa para guardá-la nas favoritas.',
  'explore.empty.hint.mine': 'Crie uma mesa para começar a narrar.',
  'explore.sort': 'Ordenação: {mode}',
  'explore.sort.recommendation': 'recomendação',
  'explore.sort.onlinePlayersQty': 'mais gente online',
  'explore.loading': 'Carregando…',
  'explore.search.words': 'Nome, sistema, mestre, status ou descrição',
  'explore.search.label': 'Buscar mesas',
  'explore.facets': 'Filtros',
  'explore.facets.status': 'Situação',
  'explore.facets.system': 'Sistema',
  'explore.facets.noSystems': 'Nenhuma mesa daqui diz o sistema.',
  'explore.facets.allSystems': 'Mostrar todos ({n})',
  'explore.facets.fewerSystems': 'Mostrar menos',
  'explore.facets.tagsHint': 'Um toque mostra só as mesas com a característica; o segundo, só as sem ela; o terceiro tira o filtro.',
  'explore.facets.clear': 'Limpar filtros',
  'explore.facets.language': 'Língua',
  'explore.facets.noLanguages': 'Nenhuma mesa daqui diz a língua.',
  'explore.facets.frequency': 'Frequência',
  'explore.facets.visuals': 'Visual',
  'explore.facets.pay': 'Cobrança',
  'explore.facets.pay.any': 'Qualquer',
  'explore.facets.pay.free': 'Gratuitas',
  'explore.facets.pay.paid': 'Pagas',
  'explore.tag.any': 'qualquer',
  'explore.tag.in': 'só com ela',
  'explore.tag.out': 'só sem ela',
  'explore.tag.without': 'sem {name}',
  'explore.count.one': '1 mesa',
  'explore.count.many': '{n} mesas',
  'explore.sortLabel': 'Ordenar',
  'explore.layout': 'Visualização',
  'explore.layout.grid': 'Grade',
  'explore.layout.list': 'Lista',
  'explore.card.open': 'Ver detalhes de {name}',
  'explore.empty.filtered': 'Nenhuma mesa com estes filtros',
  'explore.empty.filtered.text': 'Tire um filtro, troque de sistema ou veja todas as mesas.',
  'explore.empty.online': 'Ninguém jogando agora',
  'explore.empty.online.text': 'Quando alguém entrar numa mesa pública, ela aparece aqui.',
  'explore.empty.discover': 'Você já passou por todas as mesas públicas',
  'explore.empty.discover.text': 'As mesas novas aparecem aqui.',
  'explore.empty.search': 'Nenhuma mesa pública ainda',
  'explore.empty.search.text': 'Crie a primeira: ela aparece aqui para quem procura.',
  'explore.empty.all': 'Ver todas as mesas',
  'explore.empty.create': 'Criar uma mesa',
  'explore.search.withoutPassword': 'Sem senha',
  'explore.search.withGMOnline': 'Mestre na mesa',
  'explore.card.gmOnline': 'Mestre na mesa',
  'explore.card.gmOffline': 'Mestre fora',
  'explore.card.password': 'Com senha',
  'explore.card.mine': 'Sua mesa',
  'explore.card.auxGm': 'Você é mestre',
  'explore.card.vacancies': 'Procura jogadores',
  'explore.card.adult': '+18',
  'explore.card.gm': 'Mestre',
  'explore.card.gmHere': 'na mesa',
  'explore.card.nobody': 'Ninguém agora',
  'explore.card.playing.one': '1 na mesa',
  'explore.card.playing.many': '{n} na mesa',
  'explore.filters.show': 'Mostrar {count}',
  'explore.filters.more': 'Mais filtros',
  'explore.card.menu': 'Ações da mesa {name}',
  'explore.menu.like': 'Curtir esta mesa',
  'explore.menu.unlike': 'Desfazer curtida',
  'explore.menu.dislike': 'Não curti',
  'explore.menu.undislike': 'Desfazer "não curti"',
  'explore.menu.favorite': 'Guardar nas favoritas',
  'explore.menu.unfavorite': 'Tirar das favoritas',
  'explore.menu.overview': 'Ver detalhes',
  'explore.menu.copyLink': 'Copiar link da mesa',
  'explore.menu.copied': 'Link copiado.',
  'explore.overview.onlineNow': 'Na mesa agora',
  'explore.overview.created': 'Criada em',
  'explore.overview.visited': 'Sua última visita: {when}',
  'explore.overview.notVisited': 'Você ainda não entrou nesta mesa',
  'explore.overview.description': 'Descrição',
  'explore.overview.about': 'Sobre a mesa',
  'explore.overview.details': 'Como é a mesa',
  'explore.overview.password': 'Senha da mesa',
  'explore.overview.join': 'Entrar na mesa',
  'explore.overview.rejoin': 'Voltar para a mesa',
  'explore.overview.likes.one': '1 curtida',
  'explore.overview.likes.many': '{n} curtidas',
  'explore.overview.dislikes.one': '1 não curtiu',
  'explore.overview.dislikes.many': '{n} não curtiram',
  'create.title': 'Nova mesa',
  'create.name': 'Nome da mesa',
  'create.name.prompt': 'Algo que chame atenção',
  'create.name.tooShort': 'Use pelo menos {n} letras.',
  'create.system': 'Sistema',
  'create.system.prompt': 'D&D 5e, Tormenta20, Vampiro…',
  'create.complement': 'Complemento',
  'create.complement.prompt': 'Edição, cenário, suplemento…',
  'create.tags': 'Características',
  'create.password.toggle': 'Pedir senha para entrar',
  'create.password': 'Senha',
  'create.welcome': 'Mensagem de boas-vindas',
  'create.welcome.prompt': 'Aparece no chat para quem entra',
  'create.private': 'Esconder do Explorar',
  'create.submit': 'Criar e entrar',
  'create.cancel': 'Cancelar',
  'roomDetails.none': 'Não informado',
  'roomDetails.language': 'Língua',
  'roomDetails.frequency': 'Frequência',
  'roomDetails.frequency.several-weekly': 'Várias vezes por semana',
  'roomDetails.frequency.weekly': 'Semanal',
  'roomDetails.frequency.biweekly': 'Quinzenal',
  'roomDetails.frequency.monthly': 'Mensal',
  'roomDetails.frequency.irregular': 'Irregular',
  'roomDetails.frequency.one-shot': 'Sessão única',
  'roomDetails.visuals': 'Visual',
  'roomDetails.visuals.maps': 'Mapas e tokens',
  'roomDetails.visuals.some-images': 'Algumas imagens',
  'roomDetails.visuals.theater-of-mind': 'Teatro da mente',
  'roomDetails.payToPlay': 'Cobro para mestrar',
  'roomDetails.payToPlay.desc': 'Mostra o selo Pago no cartão da mesa. Quem procura mesa pode filtrar só as gratuitas ou só as pagas.',
  'roomDetails.price': 'Valor',
  'roomDetails.price.prompt': 'Ex.: R$ 20 por sessão',
  'roomDetails.free': 'Gratuita',
  'roomDetails.paid': 'Paga',
  'roomDetails.paidWithPrice': 'Paga · {price}',
  'roomDetails.about': 'Sobre a mesa',
  'roomDetails.about.prompt': 'Como são as sessões, o que esperar da mesa, o que os jogadores precisam ter…',
  'home.greeting.morning': 'Bom dia, {name}',
  'home.greeting.afternoon': 'Boa tarde, {name}',
  'home.greeting.evening': 'Boa noite, {name}',
  'home.tagline': 'A mesa está posta. Os dados também.',
  'home.search': 'Buscar salas, sistemas ou mestres',
  'home.create': 'Criar sala',
  'home.hero.enter': 'Entrar na mesa',
  'home.hero.back': 'Voltar à mesa',
  'home.hero.invite': 'Convidar jogadores',
  'home.hero.invited': 'Link da mesa copiado. Mande para quem vai jogar.',
  'home.hero.gm': 'Mestre presente',
  'home.hero.seen.now': 'Você esteve aqui agora há pouco',
  'home.hero.seen.minutes': 'Você esteve aqui há {n} min',
  'home.hero.seen.hours': 'Você esteve aqui há {n} h',
  'home.hero.seen.yesterday': 'Você esteve aqui ontem',
  'home.hero.seen.days': 'Você esteve aqui há {n} dias',
  'home.hero.seen.unknown': '',
  'home.online.none': 'Ninguém na mesa agora',
  'home.online.one': '1 pessoa na mesa agora',
  'home.online.many': '{n} pessoas na mesa agora',
  'home.visit.now': 'Última visita agora há pouco',
  'home.visit.minutes': 'Última visita há {n} min',
  'home.visit.hours': 'Última visita há {n} h',
  'home.visit.yesterday': 'Última visita ontem',
  'home.visit.days': 'Última visita há {n} dias',
  'home.visit.unknown': 'Você ainda não entrou',
  'home.rooms.title': 'Suas mesas',
  'home.rooms.seeAll': 'Ver todas as salas',
  'home.rooms.filter': 'Filtrar mesas',
  'home.rooms.all': 'Mostrar todas ({n})',
  'home.group.recent': 'Recentes',
  'home.group.favorites': 'Favoritas',
  'home.group.mine': 'Minhas',
  'home.card.enter': 'Entrar em {name}',
  'home.newRoom.title': 'Criar nova mesa',
  'home.newRoom.text': 'Monte a sala, convide o grupo e role a iniciativa.',
  'home.empty.recent': 'Nenhuma mesa recente',
  'home.empty.favorites': 'Nenhuma mesa favorita ainda',
  'home.empty.favorites.text': 'Abra o menu ⋮ de uma mesa e escolha “Guardar nas favoritas” para fixá-la aqui.',
  'home.empty.mine': 'Você ainda não criou uma mesa',
  'home.explore.title': 'Procurando uma nova mesa?',
  'home.explore.text': 'Encontre salas abertas pelo sistema que você joga e fale direto com o mestre.',
  'home.explore.systems': 'Sistemas mais jogados',
  'home.explore.go': 'Explorar salas',
  'home.explore.short': 'Explorar',
  'roomTag.campaign': 'Campanha',
  'roomTag.one-shot': 'Aventura de uma sessão',
  'roomTag.beginners': 'Bom para iniciantes',
  'roomTag.veterans': 'Para veteranos',
  'roomTag.fantasy': 'Fantasia',
  'roomTag.horror': 'Terror',
  'roomTag.sci-fi': 'Ficção científica',
  'roomTag.modern': 'Contemporâneo',
  'roomTag.historical': 'Histórico',
  'roomTag.investigation': 'Investigação',
  'roomTag.comedy': 'Comédia',
  'roomTag.intrigue': 'Intriga',
  'roomTag.combat': 'Muito combate',
  'roomTag.roleplay': 'Muita interpretação',
  'roomTag.voice': 'Usa voz',
  'roomTag.text-only': 'Só texto',
  'roomTag.homebrew': 'Regras da casa',
  'roomTag.mature': 'Temas adultos',

  'cmd.unknown': 'Não conheço o comando {cmd}. Digite {help} para ver a lista.',
  'cmd.failed': 'O comando /{cmd} não deu certo.',
  'cmd.help.heading': 'Comandos do chat',
  'cmd.help.formatting': '**Formatação:** _itálico_, **negrito**, *ação*, "fala", --fala com travessão--, ((fora do personagem)), {L}etra capitular, [§K4]cor[§O]',
  'cmd.help.title': '/ajuda',
  'cmd.help.desc': 'mostra esta lista.',
  'cmd.roll.title': '/rolar ou /r <dados>',
  'cmd.roll.desc': 'rola dados: /r 2d6+5 · /r 4d10 > 7 (sucessos contra 7) · /r ord 4d6 (em ordem) · /r 4d6a3 (os 3 mais altos) · /r 2d20b (o mais baixo) · /r 4dF · /r 1d20+5: Ataque (com mensagem).',
  'cmd.roll.empty': 'Diga o que rolar, por exemplo /r 1d20+3.',
  'cmd.me.title': '/me <ação>',
  'cmd.me.desc': 'narra uma ação do seu personagem.',
  'cmd.me.empty': 'Escreva a ação depois de /me.',
  'cmd.laugh.title': '/rir',
  'cmd.laugh.desc': 'solta uma risada no chat.',
  'cmd.laugh.default': 'hahaha',
  'cmd.cls.title': '/cls',
  'cmd.cls.desc': 'esconde o que já estava no seu chat (só para você).',
  'cmd.fls.title': '/fls',
  'cmd.fls.desc': 'mostra de novo o que o /cls escondeu.',
  'cmd.prink.title': '/prink',
  'cmd.prink.desc': 'esconde as mensagens do sistema (entradas, saídas…) do seu chat.',
  'cmd.reload.title': '/reload',
  'cmd.reload.desc': 'desfaz o /prink e o /cls.',
  'cmd.audit.title': '/audit',
  'cmd.audit.desc': 'só mestres: mostra no chat da mesa as mensagens apagadas, marcadas; de novo, esconde.',
  'cmd.audit.gmOnly': 'Só os mestres usam o /audit, no chat da mesa.',
  'cmd.part.title': '/partir <mensagem>',
  'cmd.part.desc': 'sai da mesa deixando uma despedida.',
  'cmd.nick.title': '/nick <apelido>',
  'cmd.nick.desc': 'muda como você aparece nesta mesa; sem apelido, volta ao nome da conta.',
  'cmd.fm.title': '/fm <pés>',
  'cmd.fm.desc': 'converte pés em metros, só para você: pela conta dos livros (5 pés = 1,5 m) e pela exata.',
  'cmd.fm.empty': 'Diga quantos pés, por exemplo /fm 40.',
  'cmd.mf.title': '/mf <metros>',
  'cmd.mf.desc': 'converte metros em pés, só para você: pela conta dos livros (1,5 m = 5 pés) e pela exata.',
  'cmd.mf.empty': 'Diga quantos metros, por exemplo /mf 60.',
  'cmd.length.result': '{from} = {to} (exato: {exact})',
  'cmd.length.same': '{from} = {to}',
  'room.removed.deleted': 'A mesa foi apagada por {by}.',
  'room.inviteFriends': 'Convidar amigos',
  'room.inviteFriends.menu': 'Convidar amigos…',
  'room.talkToGm': 'Falar com o mestre',
  'room.settings': 'Configurações da mesa',
  'room.settings.plugins': 'Plugins da mesa',
  'settings.nav': 'Seções das configurações',
  'settings.tab.profile': 'Perfil',
  'settings.tab.permissions': 'Permissões',
  'settings.tab.system': 'Sistema',
  'settings.save': 'Salvar',
  'settings.saved': 'Configurações salvas.',
  'settings.discard': 'Desfazer',
  'settings.profile.name': 'Nome da mesa',
  'settings.profile.status': 'Mensagem de status',
  'settings.profile.status.prompt': 'Ex.: sessão 12 neste sábado',
  'settings.profile.cover': 'Imagem de capa',
  'settings.profile.logo': 'Marca da mesa',
  'settings.profile.image.pick': 'Escolher imagem…',
  'settings.profile.image.remove': 'Remover',
  'settings.profile.image.broken': 'A imagem não abre: o arquivo saiu do Desk Cloud ou o endereço não responde.',
  'settings.profile.cover.hint': 'No alto do cartão da mesa, no Início e no Explorar.',
  'settings.profile.logo.hint': 'No círculo sobre a capa.',
  'settings.profile.vacancies': 'Procuramos jogadores',
  'settings.profile.adult': 'Conteúdo para maiores de 18',
  'settings.profile.private': 'Esconder do Explorar',
  'settings.permissions.password': 'Senha para entrar',
  'settings.permissions.password.has': 'A mesa tem senha.',
  'settings.permissions.password.none': 'A mesa está aberta.',
  'settings.permissions.password.new': 'Nova senha',
  'settings.permissions.password.set': 'Definir senha',
  'settings.permissions.password.remove': 'Tirar a senha',
  'settings.permissions.log': 'Quem lê o histórico do chat',
  'settings.permissions.log.everyone': 'Todos veem o histórico inteiro',
  'settings.permissions.log.receipt': 'Cada um vê só o que aconteceu desde que entrou pela primeira vez',
  'settings.system.auxGms': 'Mestres auxiliares',
  'settings.system.auxGms.hint': 'Entram como mestres, não precisam da senha e podem mudar as configurações.',
  'settings.system.bans': 'Banidos',
  'settings.system.bans.hint': 'Não conseguem entrar nesta mesa.',
  'settings.system.add': 'Adicionar',
  'settings.system.account': 'Nome da conta',
  'settings.system.remove': 'Remover',
  'settings.system.empty': 'Ninguém na lista.',
  'settings.system.delete': 'Apagar a mesa',
  'settings.system.delete.hint': 'Apaga a mesa, o chat e as rolagens para sempre. Só o dono pode.',
  'settings.system.delete.confirm': 'Apagar "{name}" para sempre? Digite o nome da mesa para confirmar.',
  'settings.ownerOnly': 'Só o dono e os mestres auxiliares mudam as configurações.',
  'settings.sub.profile': 'Como a mesa aparece no Explorar e para quem entra.',
  'settings.sub.game': 'As barrinhas e as linhas dos cartões dos jogadores, e o registro das sessões.',
  'settings.sub.plugins': 'As fichas e as tabelas que a mesa usa.',
  'settings.sub.permissions': 'Quem entra na mesa e o que cada um lê do chat.',
  'settings.sub.system': 'Mestres auxiliares, banidos e apagar a mesa.',
  'settings.scope': 'Vale para toda a mesa',
  'settings.scope.tip': 'Fica gravado no servidor: todos na mesa veem a mudança.',
  'settings.unsaved': 'Há alterações que ainda não foram salvas.',
  'settings.card.presentation': 'Apresentação',
  'settings.card.presentation.desc': 'O nome, o sistema e as mensagens da mesa.',
  'settings.card.tags.desc': 'Até 12, para a busca do Explorar.',
  'settings.card.images': 'Imagens',
  'settings.card.images.desc': 'Do seu Desk Cloud, do computador ou de um endereço da web. Sem imagem, o RPG Desk desenha a capa e mostra as iniciais.',
  'settings.card.explore': 'No Explorar',
  'settings.card.details': 'Como é a mesa',
  'settings.card.details.desc': 'Aparece na visão geral da mesa e serve de filtro para quem procura mesa no Explorar.',
  'settings.card.about.desc': 'O texto da visão geral da mesa, para quem a acha no Explorar. Aceita a formatação do chat.',
  'settings.card.password': 'Entrada',
  'settings.card.chat': 'Chat',
  'settings.profile.vacancies.desc': 'Mostra o selo Procura jogadores no cartão da mesa.',
  'settings.profile.adult.desc': 'Mostra o selo +18. A mesa some do Explorar de quem não quer ver mesas +18.',
  'settings.profile.private.desc': 'A mesa só é achada pelo link.',
  'settings.permissions.log.everyone.short': 'Tudo',
  'settings.permissions.log.receipt.short': 'Desde a entrada',
  'chat.event.room.name': 'mudou o nome da mesa para {value}',
  'chat.event.room.welcome': 'mudou a mensagem de boas-vindas',
  'chat.event.room.welcome.removed': 'tirou a mensagem de boas-vindas',
  'chat.event.room.status': 'mudou o status da mesa para {value}',
  'chat.event.room.status.removed': 'tirou o status da mesa',
  'chat.event.room.tags': 'mudou as características da mesa para {value}',
  'chat.event.room.tags.removed': 'tirou as características da mesa',
  'chat.event.room.password': 'mudou a senha da mesa',
  'chat.event.room.password.removed': 'tirou a senha da mesa',
  'chat.event.room.gameRules': 'mudou as regras de jogo (barrinhas e linhas dos cartões)',
  'module.pvtChat': 'Conversa privada',
  'module.pvtChat.titleFmt': '{name} (privado)',
  'module.groupPvtChat': 'Conversa em grupo',
  'module.groupPvtChat.new': 'Conversa privada em grupo…',
  'pvt.away': 'Essa pessoa saiu da mesa; ela não recebe mensagens até voltar.',
  'pvt.group.gone': 'Você não está mais nesta conversa.',
  'pvt.group.away': '(fora da mesa)',
  'pvt.group.invite': 'Convidar mais',
  'pvt.group.leave': 'Sair da conversa',
  'pvt.group.invite.title': 'Convidar para a conversa',
  'pvt.group.invite.action': 'Convidar',
  'pvt.group.invite.empty': 'Todo mundo da mesa já está na conversa.',
  'pvt.group.new.title': 'Nova conversa privada em grupo',
  'pvt.group.new.action': 'Criar conversa',
  'pvt.group.new.empty': 'Não há mais ninguém na mesa agora.',
  'users.menu.dm': 'Conversar',
  'users.menu.pvt': 'Conversar em particular',
  'users.menu.groupPvt': 'Começar conversa em grupo',
  'users.newGroup': 'Conversa em grupo',
  'chat.event.groupCreated': 'começou a conversa em grupo',
  'chat.event.groupInvited': 'chamou {target} para a conversa',
  'chat.event.groupParted': 'saiu da conversa',
  'chat.event.chatCleared': 'limpou o chat',
  // relógio da sessão (docs/spec/session-clock.md): as linhas do chat e a pílula
  'chat.event.session.start': 'Sessão {n} começou {when}',
  'chat.event.session.pause': 'Pausa {when}',
  'chat.event.session.pause.auto': 'Pausa automática {when} · nenhum mestre na mesa',
  'chat.event.session.resume': 'Voltamos {when} · pausa de {pause}',
  'chat.event.session.end': 'Sessão {n} terminou {when} · {played} de jogo',
  'chat.event.session.end.paused': ' · {paused} de pausa',
  'chat.event.session.by': 'por {name}',
  'clock.label': 'Relógio da sessão',
  'clock.start': 'Começar a sessão {n}',
  'clock.pause': 'Pausar a sessão',
  'clock.resume': 'Continuar a sessão',
  'clock.end': 'Encerrar a sessão',
  'clock.end.menu': 'Encerrar a sessão…',
  'clock.end.ask': 'Encerrar agora?',
  'clock.end.yes': 'Encerrar',
  'clock.end.no': 'Não encerrar',
  'clock.end.confirm': 'Encerrar a sessão {n}, com {played} de jogo?',
  'clock.menu': 'Relógio da sessão: pausar ou encerrar',
  'clock.paused': 'pausa',
  'clock.ended': 'Sessão {n} · {played}',
  'clock.rate': 'Avaliar',
  'clock.rate.session': 'Avaliar a sessão',
  'clock.rate.players': 'Avaliar os jogadores',
  'clock.timer': 'Sessão {n}: {played} de jogo',
  'clock.timer.paused': 'Sessão {n} em pausa: {played} de jogo',
  'clock.details': 'Sessão {n} · começou às {time}',
  'clock.details.pauses.one': ' · 1 pausa, {paused}',
  'clock.details.pauses.many': ' · {count} pausas, {paused}',
  'clock.duration.under': 'menos de 1 min',
  'clock.duration.minutes': '{m} min',
  'clock.duration.hours': '{h}h',
  'clock.duration.hoursMinutes': '{h}h{mm}',
  'clock.at': 'às {time}',
  'clock.atDay': 'em {day}, às {time}',
  // a aba Sessões (docs/spec/session-clock.md): a sessão aberta e o registro das anteriores
  'sessions.unavailable': 'Este servidor ainda não tem o relógio da sessão.',
  'sessions.off': 'O registro das sessões está desligado nesta mesa.',
  'sessions.none': 'Nenhuma sessão em andamento.',
  'sessions.empty': 'Aqui fica o registro de cada sessão de jogo: quanto durou, as pausas, quem esteve e as notas do mestre.',
  'sessions.eyebrow': 'Sessão {n} · {day}',
  'sessions.status.running': 'Em jogo',
  'sessions.status.paused': 'Pausada',
  'sessions.startedAt': 'Começou às {time}',
  'sessions.timeline': 'Linha do tempo da sessão, {range}',
  'sessions.key.play': 'jogo',
  'sessions.key.pause': 'pausa',
  'sessions.people': 'Na sessão',
  'sessions.people.past': 'Quem esteve',
  'sessions.role.gm': 'mestre',
  'sessions.person.since': 'desde {time}',
  'sessions.notes': 'Notas',
  'sessions.notes.empty': 'Sem notas.',
  'sessions.edit': 'Editar',
  'sessions.edit.title': 'Título',
  'sessions.edit.notesPlaceholder': 'O que aconteceu, o que ficou para a próxima…',
  'sessions.save': 'Salvar',
  'sessions.cancel': 'Cancelar',
  'sessions.past': 'Sessões anteriores',
  'sessions.past.empty': 'Nenhuma sessão terminada ainda.',
  'sessions.more': 'Ver mais',
  'sessions.untitled': 'Sessão {n}',
  'sessions.row.played': '{played} de jogo',
  'sessions.row.paused': '{paused} de pausa',
  'sessions.row.noPause': 'sem pausa',
  'sessions.day.long': '{weekday}, {day}',
  'sessions.day.short': '{weekday} {day}',
  'sessions.range.nextDay': '{from}–{to} (dia {day})',
  'sessions.open': 'Ver as sessões',
  'sessions.open.label': 'Ver as sessões. {clock}',
  'sessions.next': 'Próxima sessão',
  'sessions.last': 'Última: {day} · {played} de jogo',
  'sessions.row.playedLabel': 'de jogo',
  'sessions.month.short.0': 'jan',
  'sessions.month.short.1': 'fev',
  'sessions.month.short.2': 'mar',
  'sessions.month.short.3': 'abr',
  'sessions.month.short.4': 'mai',
  'sessions.month.short.5': 'jun',
  'sessions.month.short.6': 'jul',
  'sessions.month.short.7': 'ago',
  'sessions.month.short.8': 'set',
  'sessions.month.short.9': 'out',
  'sessions.month.short.10': 'nov',
  'sessions.month.short.11': 'dez',
  'sessions.weekday.long.0': 'domingo',
  'sessions.weekday.long.1': 'segunda',
  'sessions.weekday.long.2': 'terça',
  'sessions.weekday.long.3': 'quarta',
  'sessions.weekday.long.4': 'quinta',
  'sessions.weekday.long.5': 'sexta',
  'sessions.weekday.long.6': 'sábado',
  'sessions.weekday.short.0': 'dom',
  'sessions.weekday.short.1': 'seg',
  'sessions.weekday.short.2': 'ter',
  'sessions.weekday.short.3': 'qua',
  'sessions.weekday.short.4': 'qui',
  'sessions.weekday.short.5': 'sex',
  'sessions.weekday.short.6': 'sáb',
  'sessions.rating.title': 'Avaliações',
  'sessions.rating.openUntil': 'Abertas até {day}',
  'sessions.rating.closedOn': 'Fechadas em {day}',
  'sessions.rating.ask': 'Como foi a sessão para você?',
  'sessions.rating.myLabel': 'Sua nota para a sessão',
  'sessions.rating.placeholder': 'O que funcionou, o que pode melhorar… (se quiser)',
  'sessions.rating.anonymous': 'Os mestres leem sem o seu nome.',
  'sessions.rating.send': 'Enviar',
  'sessions.rating.mine': 'Sua nota',
  'sessions.rating.remove': 'Tirar',
  'sessions.rating.notRated': 'Você não avaliou esta sessão.',
  'sessions.rating.aboutMe.one': 'Do mestre para você',
  'sessions.rating.aboutMe.many': 'Dos mestres para você',
  'sessions.rating.fromPlayers': 'A sessão, pelos jogadores',
  'sessions.rating.noPlayers': 'Nenhum jogador esteve nesta sessão.',
  'sessions.rating.none': 'Nenhum jogador avaliou ainda.',
  'sessions.rating.howMany.one': '1 de {total} avaliou',
  'sessions.rating.howMany.many': '{n} de {total} avaliaram',
  'sessions.rating.anonymousGm': 'As notas chegam sem o nome de quem deu.',
  'sessions.rating.players': 'Os jogadores',
  'sessions.rating.playersHint': 'Cada jogador lê a nota e o texto que você der a ele.',
  'sessions.rating.rate': 'Avaliar',
  'sessions.rating.ratePlayer': 'Avaliar {name}',
  'sessions.rating.editPlayer': 'Editar a nota de {name}',
  'sessions.rating.notRatedPlayer': 'sem nota',
  'sessions.rating.playerLabel': 'Sua nota para {name}',
  'sessions.rating.playerPlaceholder': 'Como {name} jogou? (se quiser)',
  'sessions.rating.rateSession': 'Avaliar a sessão {n}',
  'sessions.rating.ratePlayers': 'Avaliar os jogadores da sessão {n}',
  'sessions.rating.badge.average': 'Média dos jogadores: {average} de 5',
  'sessions.rating.badge.mine': 'Sua nota: {n} de 5',
  'sessions.notice.gm': '{name} avaliou você na sessão {n} de {room}',
  'sessions.notice.players.one': 'Nova avaliação da sessão {n} de {room}',
  'sessions.notice.players.many': '{count} avaliações novas da sessão {n} de {room}',
  'sessions.notice.view': 'Ver',
  'sessions.delete': 'Apagar esta sessão…',
  'sessions.delete.title': 'Apagar a sessão {n}?',
  'sessions.delete.confirm': 'O registro dela some para todos na mesa: o tempo de jogo, as pausas, quem esteve, o título e as notas, junto com as linhas dela no chat. Não dá para desfazer.',
  'sessions.delete.confirmOpen': 'A sessão em andamento para e some para todos na mesa: o tempo de jogo, as pausas, quem está, o título e as notas, junto com as linhas dela no chat. Não dá para desfazer.',
  'sessions.delete.yes': 'Apagar',
  'sessions.deleted': 'Sessão {n} apagada',
  'chat.tool.sendFile': 'Enviar arquivo',
  'chat.file.download': 'Baixar',
  'chat.file.missing': '(arquivo indisponível: {name})',
  'chat.image.missing': '(imagem indisponível)',
  'chat.drop.imageName': 'imagem',
  'chat.attached': 'Anexos',
  'chat.attached.sending': 'enviando…',
  'chat.attached.remove': 'Tirar {name}',
  'chat.attach.computer': 'Do computador…',
  'chat.attach.cloud': 'Do Desk Cloud…',
  'chat.attach.cloudTitle': 'Anexar do Desk Cloud',
  'chat.attach.cloudAction': 'Anexar',
  'chat.attach.cloudEmpty': 'Seu Desk Cloud ainda está vazio.',
  'chat.attach.cloudHint': 'Os arquivos ficam ligados à mesa: quem está nela pode abri-los.',
  'chat.input.withAttachment': 'Escreva algo para ir junto, ou aperte Enter para enviar',
  'imageViewer.title': 'Imagem',
  'imageViewer.open': 'Ver em tamanho grande: {name}',
  'imageViewer.openTab': 'Abrir em outra aba',
  'chat.drop': 'Solte para enviar',
  'library.add': 'Novo item',
  'library.newSheet.default': 'Novo personagem',
  'library.newSheet': 'Nova ficha…',
  'library.newSheet.title': 'Nova ficha',
  'library.newSheet.name': 'Nome da ficha (opcional)',
  'library.newSheet.search': 'Procurar sistema',
  'library.newSheet.systems': 'Sistemas',
  'library.newSheet.none': 'Nenhum sistema encontrado.',
  'library.noPlugins': 'Nenhum plugin de ficha instalado na mesa',
  'library.installPlugin': 'Instalar plugin…',
  'library.pluginInstalled': 'Plugin "{name}" instalado na mesa.',
  'library.pluginFailed': 'Não foi possível instalar o plugin: {message}',
  'library.pluginUpdated': 'Plugin "{name}" atualizado para a versão {version}.',
  'library.tooLarge': 'A ficha, cena ou tabela chegou ao tamanho máximo: a última mudança foi desfeita.',
  'library.open': 'Abrir',
  'library.openWindow': 'Abrir em nova janela',
  'library.rename': 'Renomear',
  'library.moveTo': 'Mover para…',
  'library.moveTo.title': 'Mover "{name}" para',
  'library.moveTo.root': 'Raiz da biblioteca',
  'library.delete': 'Apagar',
  'library.delete.confirm': 'Apagar "{name}"? Não dá para desfazer.',
  'library.delete.folderConfirm': 'Apagar a pasta "{name}" e tudo o que está dentro dela?',
  'library.mine': 'sua',
  'library.empty.gm': 'A biblioteca está vazia. Pelo botão + você cria cenas, pastas e fichas e instala plugins de ficha.',
  'sheet.gone': 'Esta ficha não existe mais.',
  'sheet.noPlugin': 'Nenhum plugin da mesa edita fichas do tipo {type}. Os dados da ficha continuam guardados: instale o plugin de novo para voltar a editá-la.',
  'module.charSheet': 'Ficha',
  'common.ok': 'OK',
  'common.search': 'Buscar',
  'common.search.clear': 'Limpar busca',
  'common.noResults': 'Nada encontrado.',
  'common.close': 'Fechar',
  'common.back': 'Voltar',
  'common.language': 'Idioma',
  'library.newScene': 'Nova cena',
  'library.scene': 'Cena',
  'library.create': 'Criar',
  'scene.addToken': 'Adicionar token no centro da vista',
  'scene.background': 'Escolher a imagem do mapa',
  'scene.mapImage': 'Mapa',
  'scene.bg.choose': 'Escolher imagem…',
  'scene.bg.replace': 'Trocar imagem…',
  'scene.bg.remove': 'Remover imagem',
  'scene.cols': 'Colunas',
  'scene.rows': 'Linhas',
  'scene.gridSize': 'Célula (px)',
  'scene.cellDistance': 'Cada célula vale',
  'scene.cellUnit': 'Unidade',
  'scene.unit.m': 'm',
  'scene.unit.feet': 'pés',
  'scene.unit.foot': 'pé',
  'scene.gridColor': 'Cor da grade',
  'scene.gridOpacity': 'Opacidade da grade',
  'scene.gridVisible': 'Mostrar a grade',
  'scene.fog.enabled': 'Névoa de guerra (os jogadores só veem o que foi revelado)',
  'scene.fog.off': 'Tirar a névoa',
  'scene.empty': 'O mestre ainda não montou esta cena.',
  'scene.empty.gm': 'Escolha a imagem do mapa, adicione tokens ou arraste imagens para cá.',
  'scene.fit': 'Enquadrar o mapa (0)',
  'scene.gone': 'Esta cena foi apagada da biblioteca.',
  'scene.loading': 'Carregando a cena…',
  'scene.save': 'Salvar',
  'scene.settings': 'Configurar a cena',
  'scene.token': 'Token',
  'scene.token.defaultName': 'Token {n}',
  'scene.token.properties': 'Propriedades do token',
  'scene.token.name': 'Nome',
  'scene.token.image': 'Escolher imagem…',
  'scene.token.noImage': 'Sem imagem',
  'scene.token.color': 'Cor',
  'scene.token.size': 'Tamanho',
  'scene.token.sizeCells': '{n} × {n} células',
  'scene.token.hp': 'Vida',
  'scene.token.hpMax': 'Vida máxima',
  'scene.token.showName': 'Mostrar o nome no mapa',
  'scene.token.layer': 'Camada',
  'scene.layer.map': 'Mapa (embaixo de tudo)',
  'scene.layer.tokens': 'Tokens',
  'scene.layer.gm': 'Só o mestre vê',
  'scene.token.hidden': 'Oculto dos jogadores',
  'scene.token.controllers': 'Quem pode mover',
  'scene.token.nobody': 'Ninguém mais está na mesa agora.',
  'scene.token.offline': '(pessoa fora da mesa)',
  'scene.token.show': 'Mostrar aos jogadores',
  'scene.token.hide': 'Ocultar dos jogadores',
  'scene.token.front': 'Trazer para a frente',
  'scene.token.back': 'Mandar para trás',
  'scene.token.delete': 'Apagar token',
  'scene.token.deleteConfirm': 'Apagar o token "{name}"?',
  'scene.token.notYours': 'Só o mestre mexe neste token',
  'scene.tool.select': 'Selecionar e mover (V)',
  'scene.tool.pan': 'Arrastar a vista (H)',
  'scene.tool.ruler': 'Régua (R)',
  'scene.tool.reveal': 'Revelar área da névoa (F)',
  'scene.tool.hide': 'Cobrir área com névoa',
  'scene.tool.fog': 'Ferramentas de névoa',
  'scene.uploadFailed': 'Não foi possível enviar a imagem: {message}',
  'scene.uploading': 'Enviando…',
  'scene.viewport': 'Mapa da cena',
  'scene.writeFailed': 'A cena não aceitou a mudança: {message}',
  'scene.zoomIn': 'Aproximar',
  'scene.zoomOut': 'Afastar',
  'audio.nowPlaying': 'Tocando agora',
  'audio.nothing': 'Nada na playlist',
  'audio.failed': 'Não foi possível abrir esta faixa.',
  'audio.blocked': 'O navegador segurou o som da mesa. Clique para ouvir.',
  'audio.seek': 'Posição da música',
  'audio.controls': 'Controles da música',
  'audio.prev': 'Anterior',
  'audio.next': 'Próxima',
  'audio.play': 'Tocar',
  'audio.pause': 'Pausar',
  'audio.stop': 'Parar',
  'audio.repeat.all': 'Repetir a playlist',
  'audio.repeat.one': 'Repetir esta música',
  'audio.repeat.off': 'Sem repetição',
  'audio.gmControls': 'O mestre controla a música da mesa.',
  'audio.myVolume': 'Meu volume',
  'audio.roomVolume': 'Volume da mesa',
  'audio.playlist': 'Playlist',
  'audio.addFiles': 'Enviar arquivos de áudio…',
  'audio.addLink': 'Adicionar por link…',
  'audio.playThis': 'Tocar esta',
  'audio.remove': 'Remover',
  'audio.removeNamed': 'Remover {name}',
  'audio.empty': 'O mestre ainda não montou a playlist.',
  'audio.empty.gm': 'Envie arquivos de áudio ou adicione links. Dá para arrastar arquivos para cá.',
  'audio.notAudio': 'Nenhum desses arquivos é de áudio.',
  'audio.uploadFailed': 'Não foi possível enviar: {message}',
  'audio.link.title': 'Adicionar por link',
  'audio.link.url': 'Endereço do arquivo de áudio (http ou https)',
  'audio.link.name': 'Nome que aparece na lista',
  'audio.link.next': 'Continuar',
  'audio.link.add': 'Adicionar',
  'audio.link.defaultName': 'Faixa',
  'audio.link.invalid': 'Use um endereço que comece com http:// ou https://.',
  'sfx.add': 'Adicionar efeito',
  'sfx.volume': 'Volume dos efeitos',
  'sfx.playFor': 'Tocar para a mesa',
  'sfx.play': 'Tocar para a mesa',
  'sfx.empty': 'Nenhum efeito no quadro.',
  'sfx.empty.gm': 'Nenhum efeito ainda. Use o + ou arraste arquivos de áudio para cá.',
  'sfx.gmOnly': 'Só os mestres disparam os efeitos.',
  'voice.inCallCount': '{n} na conferência',
  'voice.outOfCall': 'fora da conferência',
  'voice.intro': 'Converse por voz e vídeo com a mesa. O som vai direto entre os computadores; o servidor do RPG Desk só apresenta um ao outro.',
  'voice.join': 'Entrar na conferência',
  'voice.asking': 'Pedindo o microfone…',
  'voice.leave': 'Sair da conferência',
  'voice.micOn': 'Ligar o microfone',
  'voice.micOff': 'Silenciar o microfone',
  'voice.camOn': 'Ligar a câmera',
  'voice.camOff': 'Desligar a câmera',
  'voice.you': '{name} (você)',
  'voice.alone': 'Ninguém mais entrou na conferência ainda.',
  'voice.bigRoom': '{n} pessoas na mesa: com muita gente a conferência direta fica pesada.',
  'voice.error.mic-denied': 'O navegador não deixou usar o microfone. Libere a permissão e tente de novo.',
  'voice.error.mic-failed': 'Não foi possível abrir o microfone.',
  'voice.error.cam-failed': 'Não foi possível abrir a câmera.',
  'voice.error.connect-failed': 'A conexão com uma pessoa falhou.',
  'voice.error.negotiate-failed': 'A conexão com uma pessoa falhou.',
  'settings.system.delete.mismatch': 'O nome digitado não confere; a mesa não foi apagada.',
  'friends.title': 'Amigos e chat',
  'friends.head': 'Amigos',
  'friends.summary': '{online} online',
  'friends.me.menu': 'Meu status',
  'friends.me.status': 'Meu status: {status}',
  'friends.me.online': 'Online',
  'friends.me.online.hint': 'Os amigos veem você online. Depois de 10 min sem usar o RPG Desk, você aparece Ausente.',
  'friends.me.busy': 'Ocupado',
  'friends.me.busy.hint': 'Os amigos veem que você está ocupado. As mensagens chegam sem som, sem aviso e sem abrir a conversa.',
  'friends.me.offline': 'Offline',
  'friends.me.offline.hint': 'Os amigos veem você offline. Você continua vendo os amigos e recebendo as mensagens.',
  'friends.me.notConnected': 'Sem conexão com o servidor: o status não mudou.',
  'friends.unread': '{n} mensagens não lidas',
  'friends.loading': 'Carregando…',
  'friends.search': 'Buscar amigos',
  'friends.tab.friends': 'Amigos',
  'friends.tab.requests': 'Pedidos',
  'friends.tab.blocked': 'Bloqueados',
  'friends.add': 'Adicionar amigo',
  'friends.add.placeholder': 'Nome de usuário',
  'friends.add.send': 'Enviar',
  'friends.add.suggestions': 'Pessoas com esse nome',
  'friends.group.room': 'Na mesa',
  'friends.group.online': 'Online',
  'friends.group.offline': 'Offline',
  'friends.group.hidden': 'Escondidos',
  'friends.group.others': 'Outras conversas',
  'friends.status.typing': 'digitando…',
  'friends.status.typingName': '{name} está digitando…',
  'friends.status.room': 'Na mesa · {room}',
  'friends.status.room.away': 'Ausente · {room}',
  'friends.status.room.busy': 'Ocupado · {room}',
  'friends.status.someRoom': 'Numa mesa',
  'friends.status.someRoom.away': 'Ausente · numa mesa',
  'friends.status.someRoom.busy': 'Ocupado · numa mesa',
  'friends.status.away': 'Ausente',
  'friends.status.busy': 'Ocupado',
  'friends.status.online': 'Online',
  'friends.status.offline': 'Offline · {seen}',
  'friends.status.offlineOnly': 'Offline',
  'friends.status.notFriend': 'Não é seu amigo',
  'friends.seen.now': 'visto agora há pouco',
  'friends.seen.minutes': 'visto há {n} min',
  'friends.seen.hours': 'visto há {n} h',
  'friends.seen.yesterday': 'visto ontem',
  'friends.seen.days': 'visto há {n} dias',
  'friends.empty': 'Você ainda não tem amigos aqui. Adicione alguém pelo nome em Pedidos.',
  'friends.noMatch': 'Nenhum amigo chamado “{q}”.',
  'friends.searchPeople': 'Procurar “{q}” no RPG Desk',
  'friends.more': 'Mais opções para {name}',
  'friends.menu.chat': 'Conversar',
  'friends.menu.profile': 'Ver perfil',
  'friends.menu.invite': 'Chamar para esta mesa',
  'friends.menu.hide': 'Esconder da lista',
  'friends.menu.unhide': 'Mostrar na lista',
  'friends.menu.remove': 'Desfazer amizade',
  'friends.menu.block': 'Bloquear',
  'friends.menu.add': 'Adicionar amigo',
  'friends.menu.dismiss': 'Tirar da lista',
  'friends.remove.confirm': 'Desfazer a amizade com {name}? Vocês deixam de se ver na lista e de conversar por aqui.',
  'friends.block.confirm': 'Bloquear {name}? A amizade se desfaz, e a pessoa não consegue mais te mandar mensagens, pedidos nem convites para mesas.',
  'friends.request.title': 'Adicionar {name}',
  'friends.request.note': 'Mensagem para acompanhar o pedido (opcional)',
  'friends.request.send': 'Enviar pedido',
  'friends.request.sent': 'Pedido de amizade enviado para {name}.',
  'friends.requests.sent': 'Enviados — {n}',
  'friends.requests.received': 'Recebidos — {n}',
  'friends.requests.waiting': 'Aguardando resposta',
  'friends.requests.cancel': 'Cancelar',
  'friends.requests.wants': 'Quer ser seu amigo',
  'friends.requests.accept': 'Aceitar pedido de {name}',
  'friends.requests.decline': 'Recusar pedido de {name}',
  'friends.requests.none': 'Nenhum pedido novo.',
  'friends.blocked.none': 'Ninguém bloqueado',
  'friends.blocked.hint': 'Quem você bloquear não consegue te mandar mensagens nem convites para mesas.',
  'friends.blocked.unblock': 'Desbloquear',
  'friends.chat.region': 'Conversa com {name}',
  'friends.chat.log': 'Mensagens com {name}',
  'friends.chat.write': 'Mensagem para {name}',
  'friends.chat.send': 'Enviar mensagem',
  'friends.chat.first': 'Comece a conversa com {name}.',
  'friends.chat.stranger': 'Vocês ainda não são amigos.',
  'friends.chat.pending': 'Pedido de amizade pendente.',
  'friends.chat.friendsOnly': '{name} só recebe mensagens de amigos.',
  'friends.chat.blockedByMe': 'Você bloqueou {name}.',
  'friends.chat.unavailable': 'Não é possível mandar mensagens para {name}.',
  'friends.chat.minimize': 'Minimizar a conversa com {name}',
  'friends.chat.expand': 'Expandir a conversa com {name}',
  'friends.chat.close': 'Fechar a conversa com {name}',
  'friends.chat.back': 'Voltar aos amigos',
  'friends.chat.today': 'Hoje',
  'friends.chat.yesterday': 'Ontem',
  'friends.invite.title': 'Convidar amigos para {room}',
  'friends.invite.send': 'Convidar',
  'friends.invite.sendN': 'Convidar ({n})',
  'friends.invite.done': '{n} convite(s) enviado(s).',
  'friends.invite.alreadyHere': 'Já está na mesa',
  'friends.invite.noFriends': 'Você ainda não tem amigos para convidar. Adicione alguém em Amigos e chat → Pedidos.',
  'friends.invite.received': '{name} te chamou para a mesa {room}',
  'friends.invite.sent': 'Você chamou para a mesa {room}',
  'friends.invite.notice': 'te chamou para a mesa {room}',
  'friends.invite.enter': 'Entrar',
  'friends.invite.here': 'Você está nesta mesa',
  'friends.invite.gone': 'Esta mesa não existe mais.',
  'friends.invite.locked': 'Mesa com senha',
  'friends.invite.passwordTitle': 'Entrar em {room}',
  'friends.invite.password': 'Esta mesa tem senha. Peça a senha a quem te chamou.',
  'profile.title': 'Perfil',
  'profile.dialog': 'Perfil de {name}',
  'profile.chat': 'Conversar',
  'profile.addContact': 'Adicionar amigo',
  'profile.relation.none': 'Vocês ainda não são amigos',
  'profile.relation.sent': 'Pedido de amizade enviado',
  'profile.relation.pending': 'Pedido de amizade pendente',
  'profile.relation.friend': 'Vocês são amigos',
  'profile.relation.hidden': 'Escondido da sua lista de amigos',
  'profile.relation.blocked': 'Você bloqueou {name}',
  'profile.menu.dismiss': 'Remover das conversas',
  'profile.menu.block': 'Bloquear {name}…',
  'profile.level': 'Nível {n}',
  'profile.since': 'No RPG Desk desde {date}',
  'profile.online': 'Online agora',
  'profile.seen.now': 'Visto agora há pouco',
  'profile.seen.minutes': 'Visto há {n} min',
  'profile.seen.hours': 'Visto há {n} h',
  'profile.seen.yesterday': 'Visto ontem',
  'profile.seen.days': 'Visto há {n} dias',
  'profile.rating.title': 'Avaliação dos jogadores',
  'profile.rating.mine': 'Como os jogadores te avaliam',
  'profile.vote': 'Sua avaliação de {name}',
  'profile.like': 'Curtir',
  'profile.dislike': 'Não curtir',
  'profile.voted.like': 'Você curtiu',
  'profile.voted.dislike': 'Você não curtiu',
  'profile.voted.none': 'Você ainda não avaliou',
  'profile.raters.none': 'Ninguém avaliou {name} ainda',
  'profile.raters.one': '1 jogador avaliou {name}',
  'profile.raters.many': '{n} jogadores avaliaram {name}',
  'profile.tables.title': 'Nas mesas',
  'profile.tables.asPlayer': 'Como jogador',
  'profile.tables.asGm': 'Como mestre',
  'profile.tables.player.one': '1 avaliação de mestre',
  'profile.tables.player.many': '{n} avaliações de mestres',
  'profile.tables.gm.one': '1 avaliação de jogador',
  'profile.tables.gm.many': '{n} avaliações de jogadores',
  'profile.tables.few': '{count} · a média aparece com {min}',
  'stars.one': '1 estrela',
  'stars.many': '{n} estrelas',
  'stars.of': '{n} de 5 estrelas',
  'stars.average': 'Média: {average} de 5 estrelas',
  'profile.likes.one': 'curtida',
  'profile.likes.many': 'curtidas',
  'profile.dislikes.one': 'descurtida',
  'profile.dislikes.many': 'descurtidas',
  'profile.bio': 'Sobre',
  'profile.rpg': 'Gosta de jogar',
  'profile.times': 'Costuma jogar',
  'profile.emptyAll': '{name} ainda não escreveu nada no perfil.',
  'profile.mine.title': 'Seu perfil',
  'profile.mine.filled': '{n} de 3 preenchidos',
  'profile.mine.footer': 'É assim que os outros jogadores te veem.',
  'profile.add.bio': 'Conte um pouco sobre você como jogador ou mestre',
  'profile.add.rpg': 'Adicione os sistemas que você gosta de jogar',
  'profile.add.times': 'Diga quando você costuma jogar',
  'profile.placeholder.bio': 'Ex.: mestre há 10 anos, adoro campanhas longas',
  'profile.edit': 'Editar {field}',
  'profile.cancel': 'Cancelar',
  'profile.save': 'Salvar',
  'profile.changeAvatar': 'Trocar avatar',
  'profile.cover.change': 'Trocar capa',
  'profile.cover.pick': 'Escolher imagem…',
  'profile.cover.remove': 'Tirar a capa',
  'profile.cover.title': 'Capa do perfil',
  'profile.cover.saved': 'Capa trocada.',
  'profile.cover.removed': 'Capa removida.',
  'profile.avatar.title': 'Foto do perfil',
  'profile.avatar.uploadHint': 'A imagem vira a sua foto, recortada em quadrado e reduzida.',
  'cloud.title': 'Desk Cloud',
  'cloud.view.all': 'Todos os arquivos',
  'cloud.view.recent': 'Recentes',
  'cloud.view.favorites': 'Favoritos',
  'cloud.view.trash': 'Lixeira',
  'cloud.view.unlinked': 'Só você · sem mesa',
  'cloud.section.rooms': 'Mesas',
  'cloud.section.folders': 'Pastas',
  'cloud.section.storage': 'Armazenamento',
  'cloud.storage.of': '{used} de {quota}',
  'cloud.storage.maxFile': 'Arquivos de até {size} cada',
  'cloud.storage.plans': 'Ver planos · até {size}',
  'cloud.storage.plansOnly': 'Ver planos',
  'cloud.storage.full': 'Espaço cheio: apague arquivos ou mude de plano',
  'cloud.storage.aria': '{used} de {quota} usados',
  'cloud.storage.open': 'Ver o seu plano',
  'cloud.kind.map': 'Mapa',
  'cloud.kind.token': 'Token',
  'cloud.kind.audio': 'Áudio',
  'cloud.kind.doc': 'Documento',
  'cloud.kind.other': 'Outro',
  'cloud.kinds.all': 'Tudo',
  'cloud.kinds.map': 'Mapas',
  'cloud.kinds.token': 'Tokens',
  'cloud.kinds.audio': 'Áudio',
  'cloud.kinds.doc': 'Documentos',
  'cloud.kinds.other': 'Outros',
  'cloud.kinds.photo': 'Fotos',
  'cloud.kinds.trash': 'Lixeira',
  'cloud.root': 'a raiz',
  'cloud.files': '{n} arquivos',
  'cloud.files.one': '1 arquivo',
  'cloud.subfolders': '{n} pastas',
  'cloud.subfolders.one': '1 pasta',
  'cloud.selected': '{n} selecionados',
  'cloud.selected.one': '1 selecionado',
  'cloud.subtitle': '{files} · {size}',
  'cloud.subtitle.room': 'os {n} jogadores desta mesa podem abrir',
  'cloud.subtitle.room.one': 'o jogador desta mesa pode abrir',
  'cloud.subtitle.roomEmpty': 'ninguém mais entrou nesta mesa ainda',
  'cloud.subtitle.unlinked': 'arquivos que nenhuma mesa vê',
  'cloud.subtitle.trash': 'saem de vez depois de 30 dias',
  'cloud.upload': 'Enviar arquivos',
  'cloud.newFolder': 'Nova pasta',
  'cloud.openRoom': 'Abrir mesa',
  'cloud.search': 'Buscar em {where}',
  'cloud.search.clear': 'Limpar busca',
  'cloud.filter': 'Filtrar por tipo',
  'cloud.sort': 'Ordenar',
  'cloud.sort.recent': 'Mais recentes',
  'cloud.sort.name': 'Nome (A–Z)',
  'cloud.sort.size': 'Maiores primeiro',
  'cloud.layout': 'Modo de exibição',
  'cloud.layout.grid': 'Grade',
  'cloud.layout.list': 'Lista',
  'cloud.selectAll': 'Selecionar todos',
  'cloud.clearSelection': 'Limpar seleção',
  'cloud.select': 'Selecionar {name}',
  'cloud.bulk': 'Ações para os selecionados',
  'cloud.col.name': 'Nome',
  'cloud.col.kind': 'Tipo',
  'cloud.col.access': 'Quem pode abrir',
  'cloud.col.size': 'Tamanho',
  'cloud.col.date': 'Modificado',
  'cloud.folders': 'Pastas',
  'cloud.filesHeading': 'Arquivos',
  'cloud.folderTile': '{files} · {size}',
  'cloud.dropTile': 'Enviar arquivos',
  'cloud.dropTile.hint': 'ou arraste do computador para cá',
  'cloud.drop': 'Solte para enviar para {where}',
  'cloud.drop.hint': 'Mapas, tokens, áudio e PDFs · até {size} por arquivo',
  'cloud.drop.cloud': 'o seu Desk Cloud',
  'cloud.loadMore': 'Carregar mais',
  'cloud.empty.title': 'Nada aqui ainda',
  'cloud.empty.text': 'Envie mapas, tokens, trilhas e PDFs, ou arraste do seu computador para esta área.',
  'cloud.empty.search': 'Nada encontrado',
  'cloud.empty.searchText': 'Nenhum arquivo com «{q}» em {where}.',
  'cloud.empty.trash': 'A lixeira está vazia',
  'cloud.empty.trashText': 'Arquivos que você manda para a lixeira ficam aqui por 30 dias antes de sumirem de vez.',
  'cloud.empty.favorites': 'Sem favoritos',
  'cloud.empty.favoritesText': 'Toque na estrela de um arquivo para achá-lo rápido aqui.',
  'cloud.empty.kind': 'Nenhum arquivo deste tipo',
  'cloud.empty.kindText': 'Tente outro filtro.',
  'cloud.empty.pick': 'Escolher arquivos',
  'cloud.trashNote': 'Os itens da lixeira saem de vez depois de 30 dias e contam no seu espaço até lá.',
  'cloud.access.mine': 'Só você',
  'cloud.access.rooms': '{n} mesas',
  'cloud.access.title': 'Mesas: {rooms}',
  'cloud.access.titleMine': 'Só você pode abrir',
  'cloud.fav.add': 'Adicionar aos favoritos',
  'cloud.fav.remove': 'Tirar dos favoritos',
  'cloud.listen': 'Ouvir {name}',
  'cloud.pause': 'Pausar {name}',
  'cloud.more': 'Mais ações para {name}',
  'cloud.today': 'Hoje, {time}',
  'cloud.yesterday': 'Ontem',
  'cloud.details': 'Detalhes',
  'cloud.details.close': 'Fechar detalhes',
  'cloud.details.preview': 'Abrir a pré-visualização de {name}',
  'cloud.details.open': 'Abrir',
  'cloud.details.rename': 'Renomear',
  'cloud.details.newName': 'Novo nome',
  'cloud.details.save': 'Salvar',
  'cloud.details.use': 'Usar na mesa',
  'cloud.details.useIn': 'em',
  'cloud.details.noRoom': 'Este arquivo ainda não está em nenhuma mesa.',
  'cloud.details.link': 'Ligar a uma mesa',
  'cloud.details.useNone': 'Nenhuma ação deste tipo de arquivo nas suas mesas.',
  'cloud.details.access': 'Quem pode abrir',
  'cloud.details.manage': 'Gerenciar',
  'cloud.details.you': 'Você',
  'cloud.details.owner': 'Dono',
  'cloud.details.roomLabel': 'Mesa',
  'cloud.details.players': '{n} jogadores podem abrir',
  'cloud.details.players.one': '1 jogador pode abrir',
  'cloud.details.info': 'Informações',
  'cloud.details.type': 'Tipo',
  'cloud.details.size': 'Tamanho',
  'cloud.details.dimensions': 'Dimensões',
  'cloud.details.duration': 'Duração',
  'cloud.details.folder': 'Pasta',
  'cloud.details.sent': 'Enviado',
  'cloud.details.trashLeft': 'Sai de vez em {n} dias.',
  'cloud.details.trashLeft.one': 'Sai de vez amanhã.',
  'cloud.details.trashToday': 'Sai de vez hoje.',
  'cloud.details.pixels': '{w} × {h} px',
  'cloud.preview': 'Pré-visualização de {name}',
  'cloud.preview.close': 'Fechar a pré-visualização',
  'cloud.preview.prev': 'Arquivo anterior',
  'cloud.preview.next': 'Próximo arquivo',
  'cloud.preview.strip': 'Outros arquivos',
  'cloud.preview.onlyYou': 'Só você ouve esta prévia',
  'cloud.preview.none': 'Sem pré-visualização para .{ext}',
  'cloud.share.title': 'Quem pode abrir',
  'cloud.share.you': 'Você',
  'cloud.share.youHint': 'Dono · sempre pode abrir',
  'cloud.share.gmRooms': 'Suas mesas',
  'cloud.share.playerRooms': 'Mesas em que você joga',
  'cloud.share.gmHint': '{n} jogadores · você é mestre',
  'cloud.share.playerHint': 'você joga · só dá para desligar',
  'cloud.share.noRooms': 'Você ainda não mestra nenhuma mesa.',
  'cloud.share.note': 'Os jogadores das mesas marcadas podem abrir o arquivo. Ele continua no seu Desk Cloud: se a mesa for apagada, o arquivo volta a ser só seu.',
  'cloud.share.saved': 'Acesso atualizado',
  'cloud.share.files': '{n} arquivos',
  'cloud.folder.name': 'Nome da pasta',
  'cloud.folder.create': 'Criar',
  'cloud.folder.pick': 'Mover para',
  'cloud.folder.pickFolder': 'Mover a pasta «{name}» para',
  'cloud.folder.move': 'Mover para cá',
  'cloud.folder.inside': 'Pastas dentro de {name}',
  'cloud.folder.deleteConfirm': 'Apagar a pasta «{name}» e as pastas dentro dela? Os arquivos delas vão para a lixeira, de onde dá para restaurar por 30 dias.',
  'cloud.uploads': 'Envios',
  'cloud.uploads.sending': 'Enviando {n} arquivos…',
  'cloud.uploads.sending.one': 'Enviando 1 arquivo…',
  'cloud.uploads.done': '{n} enviados',
  'cloud.uploads.done.one': '1 enviado',
  'cloud.uploads.failed': '{n} não enviados',
  'cloud.uploads.failed.one': '1 não enviado',
  'cloud.uploads.collapse': 'Recolher os envios',
  'cloud.uploads.expand': 'Mostrar os envios',
  'cloud.uploads.close': 'Fechar os envios',
  'cloud.uploads.waiting': 'Na fila',
  'cloud.uploads.sent': 'Enviado',
  'cloud.uploads.sentTo': 'Em {room}',
  'cloud.uploads.error': 'Não enviado',
  'cloud.uploads.tooLarge': '{size}: maior que o limite de {limit} do {plan}.',
  'cloud.uploads.noSpace': 'O seu espaço está cheio.',
  'cloud.uploads.plansWith': 'Ver planos com arquivos até {size}',
  'cloud.uploads.plans': 'Ver planos',
  'cloud.uploads.cancel': 'Cancelar',
  'cloud.uploads.retry': 'Tentar de novo',
  'cloud.uploads.reveal': 'Mostrar o arquivo',
  'cloud.uploads.progress': 'Enviando {name}',
  'cloud.menu.open': 'Abrir',
  'cloud.menu.use': 'Usar na mesa',
  'cloud.menu.download': 'Baixar',
  'cloud.menu.zip': 'Baixar .zip',
  'cloud.menu.copyLink': 'Copiar link',
  'cloud.menu.rename': 'Renomear',
  'cloud.menu.moveTo': 'Mover para',
  'cloud.menu.pickFolder': 'Escolher pasta…',
  'cloud.menu.toRoot': 'Tirar da pasta',
  'cloud.menu.kind': 'Tipo',
  'cloud.menu.favorite': 'Favoritar',
  'cloud.menu.unfavorite': 'Tirar dos favoritos',
  'cloud.menu.share': 'Quem pode abrir…',
  'cloud.menu.trash': 'Mover para a lixeira',
  'cloud.menu.restore': 'Restaurar',
  'cloud.menu.purge': 'Excluir para sempre',
  'cloud.menu.emptyTrash': 'Esvaziar a lixeira',
  'cloud.menu.newFolderHere': 'Nova pasta aqui',
  'cloud.menu.uploadHere': 'Enviar arquivos para cá',
  'cloud.menu.moveFolder': 'Mover para…',
  'cloud.menu.deleteFolder': 'Apagar pasta',
  'cloud.menu.openRoom': 'Abrir a mesa',
  'cloud.menu.uploadToRoom': 'Enviar arquivos para esta mesa',
  'cloud.menu.zipRoom': 'Baixar .zip (os seus ligados a ela)',
  'cloud.menu.selectAll': 'Selecionar tudo',
  'cloud.menu.sortBy': 'Ordenar por',
  'cloud.menu.viewAs': 'Exibir como',
  'cloud.menu.reveal': 'Mostrar no Desk Cloud',
  'cloud.menu.unlink': 'Tirar desta mesa',
  'cloud.use.scene': 'Abrir como cena nova',
  'cloud.use.background': 'Usar como fundo da cena aberta',
  'cloud.use.token': 'Pôr na cena aberta',
  'cloud.use.play': 'Tocar para a mesa',
  'cloud.use.playlist': 'Pôr na playlist',
  'cloud.use.chat': 'Mandar no chat',
  'cloud.use.linked': 'Agora os jogadores de {room} podem abrir o arquivo.',
  'cloud.use.noScene': 'Abra uma cena na mesa para usar o arquivo nela.',
  'cloud.use.failed': 'Não deu para usar o arquivo na mesa.',
  'cloud.use.done.scene': '«{name}» aberto como cena',
  'cloud.use.done.background': '«{name}» é o fundo da cena',
  'cloud.use.done.token': '«{name}» posto na cena',
  'cloud.use.done.play': 'Tocando «{name}» para a mesa',
  'cloud.use.done.playlist': '«{name}» na playlist',
  'cloud.use.done.chat': '«{name}» mandado no chat',
  'cloud.toast.trashedOne': '«{name}» foi para a lixeira.',
  'cloud.toast.trashed': '{n} arquivos foram para a lixeira.',
  'cloud.toast.trashedRooms': 'As mesas deixam de vê-los.',
  'cloud.toast.restoredOne': '«{name}» foi restaurado.',
  'cloud.toast.restored': '{n} arquivos foram restaurados.',
  'cloud.toast.moved': '{n} movidos para {folder}.',
  'cloud.toast.folderDeleted': 'Pasta «{name}» apagada; {n} arquivos foram para a lixeira.',
  'cloud.toast.linkCopied': 'Link copiado. Ele expira depois de algumas horas.',
  'cloud.undo': 'Desfazer',
  'cloud.copyManually': 'Copie o link abaixo (ele expira depois de algumas horas):',
  'cloud.purge.title': 'Excluir para sempre',
  'cloud.purge.one': 'Excluir «{name}» para sempre? Mapas, músicas e mensagens que usam o arquivo deixam de mostrá-lo. Não dá para desfazer.',
  'cloud.purge.many': 'Excluir {n} arquivos para sempre? Mapas, músicas e mensagens que os usam deixam de mostrá-los. Não dá para desfazer.',
  'cloud.purge.all': 'Excluir para sempre os {n} arquivos da lixeira? Não dá para desfazer.',
  'cloud.where': 'Lugar',
  'cloud.where.pick': 'Escolher o lugar',
  'cloud.mobile.select': 'Selecionar',
  'cloud.panel.title': 'Arquivos',
  'cloud.panel.search': 'Buscar nos arquivos da mesa',
  'cloud.panel.dragHint': 'arraste para a cena',
  'cloud.panel.onScene': 'Na cena',
  'cloud.panel.playingAll': 'Tocando para todos',
  'cloud.panel.pauseAll': 'Pausar para todos',
  'cloud.panel.playAll': 'Tocar {name} para todos',
  'cloud.panel.toChat': 'Mandar {name} no chat',
  'cloud.panel.whole': 'Todo o Desk Cloud',
  'cloud.panel.send': 'Enviar',
  'cloud.panel.sendHint': 'Os envios daqui já ficam ligados a esta mesa',
  'cloud.panel.empty': 'Nenhum arquivo ligado a esta mesa ainda.',
  'cloud.panel.emptyPlayer': 'Os seus arquivos ligados a esta mesa aparecem aqui. Os do mestre chegam pela cena, pelo chat e pela música.',
  'cloud.panel.pickTitle': 'Ligar arquivos a esta mesa',
  'cloud.panel.pickAction': 'Ligar',
  'cloud.panel.pickEmpty': 'Todos os seus arquivos já estão nesta mesa.',
  'cloud.pick.emptyFolder': 'Nenhum arquivo para escolher nesta pasta.',
  'cloud.panel.unlinked': '«{name}» saiu desta mesa.',
  // Configurações (docs/spec/settings.md)
  'prefs.sections': 'Seções das configurações',
  'prefs.me': 'Ver e editar o perfil',
  'prefs.me.mobile': 'Perfil, avatar e bio',
  'prefs.search': 'Buscar configuração',
  'prefs.search.title': 'Resultados',
  'prefs.search.count': 'Resultados: {n}',
  'prefs.search.none': 'Nada encontrado. Tente “som”, “dados” ou “idioma”.',
  'prefs.search.section': 'Seção',
  'prefs.back': 'Voltar',
  'prefs.backTo': 'Voltar para as Configurações',
  'prefs.saved': 'Preferência salva.',
  'prefs.scope.account': 'Salvo na sua conta',
  'prefs.scope.account.tip': 'Vale em qualquer aparelho em que você entrar.',
  'prefs.scope.device': 'Salvo neste computador',
  'prefs.scope.device.tip': 'Fica só neste navegador.',
  'prefs.reset': 'Restaurar os padrões de {section}',
  'prefs.reset.confirm': 'Voltar {section} ao padrão?',
  'prefs.reset.yes': 'Sim, restaurar',
  'prefs.reset.done': 'Padrões de {section} restaurados.',
  'prefs.summary.myColors': 'Minhas cores',
  'prefs.summary.default': 'Padrão',
  'prefs.group.account': 'Conta',
  'prefs.group.preferences': 'Preferências',
  'prefs.group.support': 'Suporte',
  'prefs.profile.title': 'Perfil',
  'prefs.profile.sub': 'Como os outros jogadores veem você nas mesas e nos amigos.',
  'prefs.profile.kw': 'perfil foto bio sobre público',
  'prefs.profile.avatar.kw': 'foto imagem retrato',
  'prefs.profile.cover.kw': 'capa fundo faixa banner imagem',
  'prefs.profile.bio.placeholder': 'Conte um pouco sobre você como jogador ou mestre',
  'prefs.profile.rpg.placeholder': 'Ex.: D&D 5e, Tormenta20, Call of Cthulhu',
  'prefs.profile.times.placeholder': 'Ex.: como mestre, aos sábados à noite',
  'prefs.profile.preview': 'Como os outros te veem',
  'prefs.profile.empty': 'Ainda não preenchido',
  'prefs.profile.open': 'Abrir meu perfil público',
  'prefs.profile.unsaved': 'Você tem alterações no perfil que não foram salvas.',
  'prefs.profile.discard': 'Descartar',
  'prefs.profile.save': 'Salvar perfil',
  'prefs.account.title': 'Conta e segurança',
  'prefs.account.sub': 'Os dados de acesso e a privacidade da sua conta.',
  'prefs.account.kw': 'conta login acesso segurança privacidade',
  'prefs.account.access': 'Acesso',
  'prefs.account.since': 'Membro desde',
  'prefs.account.password': 'Senha',
  'prefs.account.password.desc': 'Use uma senha que você não usa em outros sites.',
  'prefs.account.password.kw': 'senha trocar mudar alterar',
  'prefs.account.privacy': 'Privacidade',
  'prefs.account.imsAnyone': 'Receber mensagens de quem não é amigo',
  'prefs.account.imsAnyone.desc': 'Desligado, só os amigos e as pessoas para quem você escreveu conseguem te mandar mensagem.',
  'prefs.account.imsAnyone.kw': 'mensagem direta privacidade amigos estranhos desconhecidos chat conversa spam',
  'prefs.account.terms.desc': 'As regras para usar o RPG Desk, que você aceitou ao criar a conta.',
  'prefs.account.terms.kw': 'termos de uso regras contrato condições',
  'prefs.account.privacyPolicy.desc': 'Quais dados o RPG Desk guarda, por quanto tempo, e como pedir uma cópia ou a remoção deles.',
  'prefs.account.privacyPolicy.kw': 'política de privacidade dados pessoais lgpd remoção cópia',
  'prefs.account.read': 'Ler',
  'prefs.account.danger': 'Zona de perigo',
  'prefs.account.delete': 'Cancelar a conta',
  'prefs.account.delete.desc': 'Encerra a sua conta no RPG Desk. O RPG Desk pede a senha antes.',
  'prefs.account.delete.kw': 'apagar excluir encerrar remover conta',
  'prefs.account.delete.confirm': 'Cancelar a conta?',
  'prefs.plan.title': 'Plano',
  'prefs.plan.sub': 'O seu plano, o espaço que ele dá e a comparação dos planos.',
  'prefs.plan.kw': 'plano espaço armazenamento arquivos limite',
  'prefs.general.title': 'Geral',
  'prefs.general.sub': 'Idioma, tela inicial, salas e cenas.',
  'prefs.general.language.kw': 'idioma língua português inglês english',
  'prefs.general.explore': 'Explorar',
  'prefs.general.adult': 'Salas para adultos (+18)',
  'prefs.general.adult.desc': 'Como as mesas marcadas como +18 aparecem no Explorar.',
  'prefs.general.adult.kw': 'adulto maiores 18 conteúdo explorar',
  'prefs.general.adult.hide': 'Ocultar',
  'prefs.general.adult.show': 'Mostrar com aviso',
  'prefs.general.table': 'Mesa virtual',
  'prefs.general.distance': 'Distâncias',
  'prefs.general.distance.kw': 'régua medir unidade metros pés movimento tokens cena',
  'prefs.general.distance.scene': 'Unidade da cena',
  'prefs.general.distance.m': 'Metros',
  'prefs.general.distance.ft': 'Pés',
  'prefs.general.distance.both': 'Metros e pés',
  'prefs.general.distance.desc.scene': 'Régua e movimento dos tokens, na unidade definida em cada cena.',
  'prefs.general.distance.desc.m': 'Régua e movimento dos tokens. Exemplo: 6 m.',
  'prefs.general.distance.desc.ft': 'Régua e movimento dos tokens. Exemplo: 20 pés (5 pés = 1,5 m).',
  'prefs.general.distance.desc.both': 'Régua e movimento dos tokens. Exemplo: 6 m (20 pés).',
  'prefs.chat.title': 'Chat',
  'prefs.chat.sub': 'Leitura e formatação das mensagens nas mesas.',
  'prefs.chat.preview': 'Prévia ao vivo',
  'prefs.chat.preview.hint': 'Reflete os ajustes abaixo',
  'prefs.chat.preview.gm': 'Mestre',
  'prefs.chat.preview.player': 'Bruna',
  'prefs.chat.preview.action': 'acende uma tocha e olha em volta.',
  'prefs.chat.preview.bar': 'Lia — PV 18 → 12',
  'prefs.chat.reading': 'Leitura',
  'prefs.chat.size.kw': 'fonte letra tamanho texto maior menor',
  'prefs.chat.timestamps.kw': 'hora horário relógio',
  'prefs.chat.formatting': 'Formatação das mensagens',
  'prefs.chat.smileys.kw': 'emoji emoticon carinha',
  'prefs.chat.table': 'Na mesa',
  'prefs.chat.bars': 'Avisar no chat quando as barras dos jogadores mudarem',
  'prefs.chat.bars.desc': 'Por exemplo, PV, mana ou outra barra da ficha.',
  'prefs.chat.bars.kw': 'barra vida pv mana aviso',
  'prefs.chat.friends': 'Painel Amigos e chat',
  'prefs.dice.title': 'Dados',
  'prefs.dice.sub': 'Aparência, animação e efeitos das suas rolagens.',
  'prefs.dice.kw': 'dados rolagem d20 3d aceleração gráfica placa vídeo webgl',
  'prefs.dice.look': 'Aparência dos seus dados',
  'prefs.dice.look.kw': 'cor cores número personalizar personalização textura imagem foto zoom estampa tamanho',
  'prefs.dice.use': 'Usar minhas cores',
  'prefs.dice.use.desc': 'Os outros jogadores veem os seus dados nessas cores e com a textura.',
  'prefs.dice.otherColor': 'outra cor',
  'prefs.dice.preview': 'Prévia do d20 com as suas cores',
  'prefs.dice.resetColors': 'Restaurar as cores padrão',
  'prefs.dice.texture': 'Textura',
  'prefs.dice.texture.desc': 'Uma imagem em cada face, com o número por cima.',
  'prefs.dice.texture.pick': 'Escolher imagem…',
  'prefs.dice.texture.remove': 'Remover',
  'prefs.dice.texture.title': 'Textura dos dados',
  'prefs.dice.textureScale': 'Tamanho da estampa',
  'prefs.dice.textureScale.desc': 'Abaixo de 100%, a imagem se repete em cada face; acima, a face mostra só o centro dela.',
  'prefs.dice.texture.broken': 'A imagem não abre: ela saiu do Desk Cloud ou o navegador não a lê. Os dados rolam só com as cores.',
  'prefs.dice.texture.refused': 'A última rolagem saiu sem a textura: a imagem foi para a lixeira ou não serve mais (PNG, JPEG, WebP ou GIF, até {max}).',
  'prefs.dice.display': 'Exibição',
  'prefs.dice.noLighting': 'Modo sem iluminação',
  'prefs.dice.noLighting.desc': 'Use se os dados 3D ficarem lentos ou com falhas de vídeo.',
  'prefs.dice.noLighting.kw': 'iluminação luz sombra lento travando falha vídeo placa gráfico desempenho',
  'prefs.dice.effects.kw': 'efeito fogo gelo ácido pedra taverna cassino natureza luz divina raio elétrico trovão crítico',
  'prefs.dice.effects.when': 'Quando',
  'prefs.dice.effects.show': 'mostrar',
  'prefs.notify.title': 'Notificações',
  'prefs.notify.sub': 'Sons e avisos do que acontece enquanto você joga.',
  'prefs.notify.banner.title': 'Os avisos do sistema estão desligados',
  'prefs.notify.banner.text': 'Sem eles, você não recebe avisos quando o RPG Desk está em segundo plano.',
  'prefs.notify.banner.blocked': 'O navegador bloqueou os avisos do RPG Desk. Para liberar, use as permissões do site (o cadeado ao lado do endereço).',
  'prefs.notify.banner.allow': 'Permitir avisos',
  'prefs.notify.volume': 'Volume geral',
  'prefs.notify.volume.kw': 'volume som alto baixo',
  'prefs.notify.listen': 'Ouvir: {name}',
  'prefs.notify.sound.kw': 'som sons alerta tocar',
  'prefs.notify.soundScene': 'Sons da cena',
  'prefs.notify.soundScene.desc': 'Portas abrindo, fechando e trancadas.',
  'prefs.notify.messages': 'Avisar mensagens diretas novas',
  'prefs.notify.unfocused': 'Em segundo plano',
  'prefs.notify.flash': 'Piscar o título da janela',
  'prefs.notify.flash.desc': 'Quando algo chega com o RPG Desk em segundo plano.',
  'prefs.av.title': 'Áudio e vídeo',
  'prefs.av.sub': 'Aparelhos e como você entra na chamada da mesa.',
  'prefs.av.kw': 'conferência chamada voz vídeo',
  'prefs.av.test': 'Teste rápido',
  'prefs.av.test.desc': 'Confira a câmera e o microfone antes de entrar na chamada.',
  'prefs.av.test.kw': 'testar microfone câmera prévia webcam',
  'prefs.av.camera.preview': 'Prévia da câmera',
  'prefs.av.camera.off': 'Câmera desligada',
  'prefs.av.camera.start': 'Ligar a prévia',
  'prefs.av.camera.stop': 'Desligar a prévia',
  'prefs.av.camera.error': 'Não deu para abrir a câmera.',
  'prefs.av.mic.level': 'Nível do microfone',
  'prefs.av.mic.idle': 'Clique em testar e fale algo: a barra deve se mexer.',
  'prefs.av.mic.live': 'Fale algo: a barra deve se mexer.',
  'prefs.av.devices': 'Aparelhos',
  'prefs.av.missing': 'Aparelho desconectado',
  'prefs.av.speaker': 'Saída de áudio',
  'prefs.av.speaker.desc': 'O fone ou o alto-falante das vozes da chamada.',
  'prefs.av.speaker.kw': 'fone alto-falante caixa som saída',
  'prefs.av.speaker.test': 'Ouvir um som de teste na saída escolhida',
  'prefs.av.speaker.error': 'Não deu para tocar nessa saída.',
  'prefs.av.join': 'Ao entrar na chamada',
  'prefs.support.title': 'Solução de problemas',
  'prefs.support.sub': 'Diagnóstico e opções para recomeçar do zero.',
  'prefs.support.kw': 'ajuda problema erro bug suporte avançado utilitários',
  'prefs.support.diagnostics': 'Diagnóstico',
  'prefs.support.log': 'Registro de erros',
  'prefs.support.log.kw': 'log erro bug baixar',
  'prefs.support.log.download': 'Baixar o registro',
  'prefs.support.dice': 'Dados 3D lentos ou com falhas?',
  'prefs.support.dice.desc': 'Ligue o modo sem iluminação, na seção Dados.',
  'prefs.support.dice.go': 'Ir para Dados',
  'prefs.support.resetAll': 'Restaurar todas as preferências',
  'prefs.support.resetAll.desc': 'Chat, dados, notificações, áudio e o resto deste computador voltam ao padrão. O idioma fica.',
  'prefs.support.resetAll.kw': 'redefinir resetar padrão fábrica',
  'prefs.support.resetAll.button': 'Restaurar…',
  'prefs.support.resetAll.confirm': 'Restaurar todas as preferências?',
  'prefs.support.resetAll.yes': 'Sim, restaurar',
  'prefs.support.resetAll.done': 'Preferências restauradas.',
  'prefs.support.layouts': 'Esquecer os arranjos das mesas',
  'prefs.support.layouts.kw': 'layout painéis abas espaços módulos organização',
  'prefs.support.layouts.button': 'Esquecer…',
  'prefs.support.layouts.confirm': 'Esquecer os arranjos de todas as mesas?',
  'prefs.support.layouts.yes': 'Sim, esquecer',
  'prefs.support.layouts.done': 'Arranjos das mesas esquecidos.',
  'config.plan.current': 'Seu plano',
  'config.plan.until': 'Vale até {date}',
  'config.plan.noExpiry': 'Sem prazo',
  'config.plan.used': '{used} de {total} usados',
  'config.plan.compare': 'Os planos',
  'config.plan.howTo': 'Para mudar de plano, fale com a administração do servidor.',
  'config.plan.yours': 'o seu',
  'config.plan.entitlement': 'O que dá',
  'config.general.app': 'Aplicativo',
  'config.general.startPage': 'Ao entrar, abrir',
  'config.general.friends.show': 'Mostrar o painel Amigos e chat',
  'config.general.friends.hint': 'O painel fica no canto de baixo, à direita, em todas as telas. Desligado, ele some, com as janelas de conversa; as mensagens dos amigos continuam chegando e ficam guardadas, e os avisos seguem as Notificações.',
  'config.general.chatSize': 'Tamanho do texto',
  'config.general.chatSpacing': 'Espaçamento entre linhas',
  'config.general.spacing.normal': 'Normal',
  'config.general.spacing.compact': 'Compacto',
  'config.general.timestamps': 'Mostrar o horário das mensagens',
  'config.general.dice3d': 'Mostrar os dados 3D nas rolagens',
  'config.account.name': 'Nome da conta',
  'config.account.changePassword': 'Trocar a senha',
  'config.account.current': 'Senha atual',
  'config.account.new': 'Nova senha',
  'config.account.again': 'Repita a nova senha',
  'config.account.rule': 'Use pelo menos 8 caracteres.',
  'config.account.mismatch': 'As duas senhas novas não são iguais.',
  'config.account.passwordChanged': 'Senha trocada.',
  'config.account.delete': 'Cancelar a conta…',
  'config.account.deleteForever': 'Apagar minha conta',
  'config.account.deleteWarning': 'Isso apaga a sua conta, as mesas que você criou, suas mensagens diretas, seus arquivos e seus contatos. O que você mandou nas mesas de outras pessoas continua nelas. Não tem volta.',
  'config.account.confirmPassword': 'Confirme com a sua senha',
  'config.profile.loading': 'Carregando o seu perfil…',
  'config.profile.saved': 'Perfil salvo.',
  'config.notify.sounds': 'Sons',
  'config.notify.soundMessages': 'Mensagem direta recebida',
  'config.notify.soundMentions': 'Alguém me menciona com @ na mesa',
  'config.notify.soundPvt': 'Conversa privada na mesa',
  'config.notify.soundKick': 'Fui expulso ou banido de uma mesa',
  'config.notify.soundRolls': 'Rolagens de dados',
  'config.notify.test': 'Ouvir',
  'config.notify.visual': 'Avisos',
  'config.notify.always': 'Sempre',
  'config.notify.never': 'Nunca',
  'config.text.hint': 'Como as marcações do texto dos outros aparecem para você.',
  'config.text.headings': 'Linhas começando com # viram títulos',
  'config.text.lines': 'Linhas com --- viram separadores',
  'config.text.smileys': 'Trocar :) e :sorriso: por emoji',
  'config.text.initialCaps': 'Letra capitular com {L} no começo',
  'config.conf.mic': 'Microfone',
  'config.conf.camera': 'Câmera',
  'config.conf.default': 'Padrão do sistema',
  'config.conf.test': 'Testar o microfone',
  'config.conf.stopTest': 'Parar o teste',
  'config.conf.micOn': 'Entrar com o microfone ligado',
  'config.conf.camOn': 'Entrar com a câmera ligada',
  'config.plugins.title': 'Plugins da mesa',
  'config.plugins.hint': 'Os plugins (fichas e tabelas em HTML) são instalados por mesa, e quem frequenta a mesa usa os plugins dela. Aqui o mestre instala e remove plugins e ativa as tabelas que eles trazem.',
  'config.plugins.version': 'versão {v}',
  'config.plugins.none': 'A mesa {room} ainda não tem plugins.',
  'config.plugins.hint.player': 'Os plugins (fichas e tabelas em HTML) são instalados por mesa, e quem frequenta a mesa usa os plugins dela. Só mestres instalam e removem plugins e ativam tabelas.',
  'config.plugins.install': 'Instalar plugin…',
  'config.plugins.remove': 'Remover',
  'config.plugins.remove.title': 'Remover o plugin "{name}"',
  'config.plugins.remove.noSheets': 'Nenhuma ficha usa este plugin.',
  'config.plugins.remove.oneSheet': '1 ficha usa este plugin.',
  'config.plugins.remove.sheets': '{count} fichas usam este plugin.',
  'config.plugins.remove.keepSheets': 'As fichas não são apagadas: continuam na biblioteca, sem poder ser editadas, até o plugin ser instalado de novo.',
  'config.plugins.remove.docks': 'As tabelas dele que estão ativas saem da mesa, com os dados guardados.',
  'config.plugins.remove.go': 'Remover plugin',
  'config.plugins.tables': 'Tabelas de {name}',
  'config.plugins.official': 'Oficial',
  'config.plugins.officialHint': 'Instalado do catálogo de plugins oficiais do RPG Desk',
  'config.tables.active': 'Ativa',
  'config.tables.stored': 'Desativada, dados guardados',
  'config.tables.off': 'Desativada',
  'config.tables.enable': 'Ativar',
  'config.tables.disable': 'Desativar',
  'config.tables.erase': 'Apagar dados',
  'config.tables.erase.label': 'Apagar dados guardados: {type}',
  'config.utils.debugHint': 'Se algo der errado, salve o registro e mande para quem cuida do servidor.',
  'config.utils.logCount': '{n} registro(s) nesta sessão',
  'config.advanced.reset': 'Recomeçar',
  'config.advanced.hint': 'As preferências e os arranjos das mesas ficam neste computador.',
  'config.advanced.resetLayoutsConfirm': 'Os módulos de cada mesa voltam ao arranjo inicial.',
  'config.text.sample': '{E}ra uma noite fria na estrada :)\n\n---\n\n# A taverna\nO anão *ergue a caneca* e diz "Saúde!" :sorriso:',
  'library.setMain': 'Usar como meu personagem principal',
  'library.unsetMain': 'Deixar de ser meu personagem principal',
  'library.main': 'principal',
  'users.menu.openSheet': 'Abrir a ficha de {name}',
  'users.menu.card': 'Barrinhas e linhas do cartão…',
  'users.menu.roomAvatar': 'Mudar minha foto nesta mesa…',
  'users.menu.roomAvatarOf': 'Mudar a foto de {name} nesta mesa…',
  'users.menu.roomAvatarRemove': 'Voltar à foto do perfil',
  'users.menu.roomAvatarRemoveOf': 'Tirar a foto de {name} nesta mesa',
  'users.roomAvatar.saved': 'Foto desta mesa trocada',
  'users.roomAvatar.removed': 'A foto do perfil voltou a valer nesta mesa',
  'users.bar.empty': 'vazia',
  'users.bar.editHint': 'clique duas vezes para mudar',
  'users.bar.edit': 'Mudar {name}',
  'users.line.editHint': 'clique duas vezes para escrever',
  'users.line.edit': 'Escrever em {name}',
  'users.barEditor.value': 'Valor atual',
  'users.barEditor.max': 'Máximo',
  'users.barEditor.hint': '+5 soma, -3 tira, =10 põe o número. Enter grava, Esc cancela.',
  'users.menu.noMainCharacter': 'Deixar de usar personagem principal',
  'users.menu.createSheet': 'Criar uma ficha para {name}…',
  'users.menu.createAnotherSheet': 'Criar outra ficha para {name}…',
  'users.menu.giveSheet': 'Dar uma ficha da biblioteca para {name}…',
  'users.menu.chooseMain': 'Escolher o personagem principal de {name}…',
  'users.giveSheet.prompt': 'A ficha passa a ser de {name}: só essa pessoa e os mestres a editam.',
  'users.chooseMain.prompt': 'O personagem principal aparece no cartão de {name}, na lista de participantes.',
  'users.chooseMain.none': 'Nenhum personagem principal',
  'library.menu.visible': 'Tornar visível para todos',
  'library.menu.invisible': 'Tornar invisível',
  'library.hidden': 'Oculto dos jogadores',
  'library.hiddenByFolder': 'Oculto dos jogadores pela pasta',
  'library.notVisible': 'Este item não está visível para você.',
  'library.menu.setOwner': 'Mudar o dono da ficha…',
  'library.setOwner.prompt': 'Quem pode editar "{sheet}", além dos mestres.',
  'library.owner.me': '{name} (você)',
  'library.owner.none': 'Ninguém: só os mestres editam',
  'library.owner.of': 'De {name}',
  'library.owner.away': 'Alguém que saiu da mesa',
  'library.newSheet.owner': 'Dono da ficha',
  'library.newSheet.titleFor': 'Nova ficha para {name}',
  'users.card.title': 'Cartão de {name}',
  'users.card.hint': 'O plugin da ficha também atualiza as barrinhas sozinho quando ela é o personagem principal.',
  'users.card.bar': 'Barra {n}',
  'users.card.value': 'Valor de {name}',
  'users.card.max': 'Máximo de {name}',
  'users.card.line': 'Linha {n}',
  'config.profile.avatar': 'Avatar',
  'config.profile.avatarHint': 'Aparece nos contatos, no seu perfil e no seu cartão nas mesas.',
  'config.profile.avatarPick': 'Escolher imagem…',
  'config.profile.avatarRemove': 'Tirar o avatar',
  'config.profile.avatarSaved': 'Avatar trocado.',
  'config.profile.avatarInvalid': 'Não foi possível usar essa imagem.',
  'config.profile.cover': 'Capa',
  'config.profile.coverPick': 'Escolher capa…',
  'config.profile.coverHint': 'A imagem no alto do seu perfil: do seu Desk Cloud, do computador ou de um endereço da web.',
  'library.exportXml': 'Exportar como XML…',
  'library.importXml': 'Importar de XML…',
  'library.importXml.confirm': 'Trocar o conteúdo de "{name}" pelo de {file}? O que está na ficha agora será substituído.',
  'library.importXml.go': 'Importar',
  'library.importXml.done': 'Ficha "{name}" importada.',
  'library.importXml.failed': 'Não foi possível importar: {message}',
  'library.dock.enable': 'Ativar tabela: {type}',
  'library.dock.disable': 'Desativar tabela: {type}',
  'library.dock.disable.confirm': 'A tabela "{type}" sai da mesa para todos. Os dados ficam guardados: ative de novo para trazê-la como estava.',
  'library.dock.disable.go': 'Desativar',
  'scene.tool.draw': 'Desenhar (D)',
  'scene.tool.erase': 'Apagar desenhos (E)',
  'scene.tool.align': 'Alinhar a grade com a imagem',
  'scene.align.title': 'Alinhar a grade com a imagem do mapa',
  'scene.align.width': 'Largura',
  'scene.align.height': 'Altura',
  'scene.align.widthValue': 'Largura da imagem em células',
  'scene.align.heightValue': 'Altura da imagem em células',
  'scene.align.narrower': 'Estreitar a imagem',
  'scene.align.wider': 'Alargar a imagem',
  'scene.align.shorter': 'Encurtar a imagem',
  'scene.align.taller': 'Alongar a imagem',
  'scene.align.move.left': 'Mover a imagem para a esquerda',
  'scene.align.move.right': 'Mover a imagem para a direita',
  'scene.align.move.up': 'Mover a imagem para cima',
  'scene.align.move.down': 'Mover a imagem para baixo',
  'scene.align.marks': 'Células marcadas: {n}',
  'scene.align.angle': 'Giro',
  'scene.align.angleValue': 'Giro da imagem em graus',
  'scene.align.turnLeft': 'Girar a imagem para a esquerda',
  'scene.align.turnRight': 'Girar a imagem para a direita',
  'scene.align.legacy': 'Esta cena é de antes do encaixe automático: a imagem está no tamanho natural e a grade pode não bater com a do mapa.',
  'scene.align.legacyFix': 'Encaixar a imagem na grade',
  'scene.align.sync': 'Sincronizar',
  'scene.align.clearMarks': 'Limpar marcas',
  'scene.align.detect': 'Detectar a grade da imagem',
  'scene.align.fitBoard': 'Encaixar o tabuleiro na imagem',
  'scene.align.hint': 'Arraste sobre células desenhadas no mapa para marcá-las (quatro, espalhadas, dão o melhor resultado) e clique em Sincronizar. Setas e botões fazem o ajuste fino (o giro, em vigésimos de grau); com Shift, o passo é 10 vezes maior.',
  'scene.align.detected': 'Grade da imagem encontrada: o mapa ficou com {cols} × {rows} células.',
  'scene.align.rounded': 'A imagem foi encaixada em {cols} × {rows} células. Se o mapa tem grade desenhada, use Alinhar para acertar.',
  'scene.align.synced': 'Grade sincronizada com as células marcadas.',
  'scene.align.redetected': 'Grade da imagem encontrada e alinhada.',
  'scene.align.none': 'Não achei uma grade desenhada nesta imagem: ela foi encaixada em {cols} × {rows} células inteiras. Para acertar, marque algumas células e clique em Sincronizar.',
  'scene.draw.options': 'Opções de desenho',
  'scene.draw.free': 'Mão livre',
  'scene.draw.rect': 'Retângulo',
  'scene.draw.ellipse': 'Elipse',
  'scene.draw.text': 'Texto',
  'scene.draw.textPrompt': 'Escreva o texto',
  'scene.draw.color': 'Cor {color}',
  'scene.draw.width.s': 'Fino',
  'scene.draw.width.m': 'Médio',
  'scene.draw.width.l': 'Grosso',
  'scene.draw.fill': 'Preencher',
  'scene.draw.eraseHint': 'Clique num desenho para apagá-lo.',
  'scene.draw.clear': 'Limpar…',
  'scene.draw.clear.mine': 'Limpar meus desenhos',
  'scene.draw.clear.players': 'Limpar desenhos dos jogadores',
  'scene.draw.clear.all': 'Limpar todos os desenhos',
  'scene.draw.clear.confirm': '{n} desenho(s) serão apagados para todos.',
  'scene.draw.clear.go': 'Apagar',
  'combat.title': 'Tracker de combate',
  'combat.loading': 'Abrindo o tracker…',
  'combat.writeFailed': 'Não deu para salvar: {message}',
  'combat.round': 'Rodada',
  'combat.add': 'Adicionar ator',
  'combat.name': 'Nome',
  'combat.actor.default': 'Ator',
  'combat.addPlayers': 'Adicionar todos os jogadores',
  'combat.addPlayers.short': '+ Jogadores',
  'combat.noPlayers': 'Nenhum jogador novo para adicionar.',
  'combat.rollAll': 'Rolar a iniciativa de todos (os que têm rolagem)',
  'combat.rollAll.short': 'Rolar',
  'combat.noRolls': 'Ninguém tem rolagem de iniciativa. Abra o ator e preencha "Rolagem".',
  'combat.rollLabel': 'Iniciativa de {name}',
  'combat.rollFailed': 'A rolagem de {name} falhou: {message}',
  'combat.turnOf': 'Turno de {name}',
  'combat.effectEnded': 'O efeito {effect} de {name} chegou ao fim',
  'combat.clear': 'Limpar',
  'combat.clear.confirm': 'Apagar todos os atores e voltar à rodada 1?',
  'combat.next': 'Próx. turno',
  'combat.prev': 'Turno anterior',
  'combat.turnBack': 'De volta ao turno de {name}',
  'combat.empty.gm': 'Adicione atores com + ou traga os jogadores com "+ Jogadores".',
  'combat.empty': 'O mestre ainda não montou o combate.',
  'combat.init': 'Iniciativa de {name}',
  'combat.side.none': 'Amigável ou hostil?',
  'combat.side.friend': 'Amigável',
  'combat.side.neutral': 'Neutro',
  'combat.side.foe': 'Hostil',
  'combat.vis.public': 'Visível para todos',
  'combat.vis.protected': 'Visível para todos, sem anotações e efeitos',
  'combat.vis.private': 'Visível só para mestres',
  'combat.remove': 'Remover ator',
  'combat.remove.confirm': 'Remover {name} do combate?',
  'combat.rollExpr': 'Rolagem de iniciativa',
  'combat.notes': 'Anotações',
  'combat.effect.add': '+ Efeito',
  'combat.effect.name': 'Efeito ou condição',
  'combat.effect.rounds': 'Duração (rodadas)',
  'combat.effect.left': '{n} rodada(s) restante(s)',
  'combat.effect.remove': 'Tirar o efeito {name}',
  'combat.nothing': 'Sem anotações nem efeitos.',
  'combat.invisible': 'Invisível: só quem vê o token vê este ator',
  'combat.link': 'Ligado a um token da cena {scene}',
  'combat.link.gone': '(cena apagada)',
  'combat.unlink': 'Desligar do token',
  'combat.protected': 'O mestre não compartilhou os detalhes.',
  'macro.manager': 'Gerenciar macros',
  'macro.new': 'Nova macro',
  'macro.newName': 'macro',
  'macro.delete': 'Apagar macro',
  'macro.delete.confirm': 'Apagar a macro /{name}?',
  'macro.tab.room': 'Da mesa (para todos)',
  'macro.tab.mine': 'Minhas desta mesa',
  'macro.tab.global': 'Minhas globais',
  'macro.hint.room': 'Todos na mesa podem usar estas macros; só mestres mudam.',
  'macro.hint.mine': 'Só você usa, e só nesta mesa. Ficam neste navegador.',
  'macro.hint.global': 'Só você usa, em todas as mesas. Ficam neste navegador.',
  'macro.empty': 'Nenhuma macro aqui ainda.',
  'macro.name': 'Nome da macro',
  'macro.name.invalid': 'Use um nome sem espaços nem "/" (até 30 caracteres).',
  'macro.name.taken': 'Já existe uma macro com esse nome aqui.',
  'macro.lines': 'Linhas da macro /{name}',
  'macro.lines.placeholder': 'Uma linha por comando, como no chat:\n/r 1d20+5\n/me ataca com a espada',
  'macro.saveFailed': 'Não deu para salvar a macro: {message}',
  'macro.tooDeep': 'A macro /{name} chama macros demais em sequência; parei aqui.',
  'macro.tooLong': 'A macro /{name} passou de {max} linhas de uma vez; parei aqui.',
  'macro.emptyRun': 'A macro /{name} está vazia.',
  'cmd.macros.title': '/macros',
  'cmd.macros.desc': 'Abre o gerenciador de macros (cada macro vira um comando /nome).',
  'room.modules': 'Módulos da mesa',
  'imagePicker.title': 'Escolher imagem',
  'imagePicker.hint': 'Clique para escolher a imagem',
  'imagePicker.tab.upload': 'Do computador',
  'imagePicker.tab.room': 'Imagens da mesa',
  'imagePicker.tab.web': 'Endereço da web',
  'imagePicker.choose': 'Escolher arquivo de imagem…',
  'imagePicker.uploading': 'Enviando…',
  'imagePicker.loading': 'Carregando…',
  'imagePicker.noRoomImages': 'Nenhuma imagem sua nesta mesa ainda.',
  'imagePicker.url': 'Endereço da imagem',
  'imagePicker.use': 'Usar',
  'imagePicker.notImage': 'Escolha um arquivo de imagem.',
  'imagePicker.tab.cloud': 'Desk Cloud',
  'imagePicker.search': 'Buscar no Desk Cloud',
  'imagePicker.noCloudImages': 'Nenhuma imagem no seu Desk Cloud ainda.',
  'imagePicker.noMatch': 'Nenhuma imagem com esse nome.',
  'imagePicker.more': 'Mostrar mais',
  'imagePicker.noFolderImages': 'Nenhuma imagem nesta pasta.',
  'imagePicker.images': 'Imagens',
  'imagePicker.allImages': 'Todas as imagens',
  'imagePicker.tooBig': 'Maior que {max}',
  'imagePicker.badType': 'Use PNG, JPEG, WebP ou GIF',
  'imagePicker.uploadHint': 'A imagem vai para o seu Desk Cloud, reduzida se for grande.',
  'imagePicker.import': 'Importar',
  'imagePicker.importing': 'Importando…',
  'imagePicker.importHint': 'Uma cópia da imagem vai para o seu Desk Cloud, reduzida se for grande.',
  'imagePicker.webFailed': 'Não deu para baixar uma imagem desse endereço.',
  'dice.rng.mark': 'Os dados da mesa usam números aleatórios reais, do random.org',
  'dice.rng.mark.fallback': 'O random.org não estava disponível na última rolagem da mesa: os números vieram do programa',
  'config.general.diceEffects': 'Mostrar efeitos especiais dos dados',
  'config.dice.effects': 'Efeitos especiais',
  'config.dice.effects.hint': 'Vão junto com as suas rolagens: todos na mesa veem os efeitos dos seus dados.',
  'config.dice.effects.none': 'Nenhum efeito: seus dados rolam sem efeitos especiais.',
  'config.dice.effects.die': 'Dado',
  'config.dice.effects.face': 'Resultado',
  'config.dice.effects.effect': 'Efeito',
  'config.dice.effects.max': 'Maior ({n})',
  'config.dice.effects.min': 'Menor (1)',
  'config.dice.effects.preview': 'Testar',
  'config.dice.effects.remove': 'Remover efeito',
  'config.dice.effects.add': 'Adicionar efeito',
  'config.dice.effects.default': 'Restaurar padrão',
  'config.dice.effects.stage': 'Clique em "Testar" para jogar um dado de teste com o efeito.',
  'config.dice.effects.no3d': 'Este navegador não mostra 3D: veja o aviso no topo desta página.',
  'config.dice.effects.failed': 'O 3D falhou neste navegador. As rolagens continuam no chat; recarregar a página costuma resolver.',
  'dice.no3d.title': 'Os dados 3D não aparecem neste navegador',
  'dice.no3d.why.gpuOff': 'A aceleração gráfica do navegador está desligada, e sem ela nenhum site desenha 3D. As rolagens continuam no chat. Para ligar:',
  'dice.no3d.why.unknown': 'O navegador não está desenhando 3D: em geral, a aceleração gráfica dele está desligada ou bloqueada. As rolagens continuam no chat. Para ligar:',
  'dice.no3d.why.policy': 'O 3D foi bloqueado por uma regra do computador (de uma empresa ou escola, por exemplo) ou por uma opção usada para abrir o navegador. Ligar a aceleração gráfica não resolve: fale com quem cuida do computador, ou use outro navegador. As rolagens continuam no chat.',
  'dice.no3d.step.open': 'Abra as configurações do navegador, pelo menu dele.',
  'dice.no3d.step.openKeys': 'Abra as configurações do navegador ({keys}).',
  'dice.no3d.step.searchAcceleration': 'Na busca das configurações, procure por “aceleração”.',
  'dice.no3d.step.searchPerformance': 'Na busca das configurações, procure por “desempenho”.',
  'dice.no3d.step.turnOn': 'Ligue {option} e reinicie o navegador.',
  'dice.no3d.step.uncheck': 'Desmarque {option}.',
  'dice.no3d.step.check': 'Marque {option} e reinicie o navegador.',
  'dice.no3d.step.quit': 'Se continuar igual, feche todas as janelas do navegador e abra de novo.',
  'dice.no3d.step.quitKeys': 'Se continuar igual, feche o navegador de vez ({keys}) e abra de novo.',
  'dice.no3d.step.safari': 'No Safari, o 3D vem ligado. Atualize o macOS, ou abra o RPG Desk no Chrome, no Opera ou no Edge.',
  'dice.no3d.option.graphics': 'Usar aceleração gráfica quando disponível',
  'dice.no3d.option.firefoxRecommended': 'Usar configurações de desempenho recomendadas',
  'dice.no3d.option.firefoxHardware': 'Usar aceleração de hardware quando disponível',
  'dice.no3d.details': 'Mensagem do navegador',
  'dice.no3d.help': 'Ver na ajuda',
  'dice.no3d.helpAnchor': 'os-dados-3d-não-aparecem',
  'dice.no3d.toast.gpuOff': 'Os dados 3D não aparecem: a aceleração gráfica deste navegador está desligada.',
  'dice.no3d.toast.unknown': 'Os dados 3D não aparecem: este navegador não está desenhando 3D.',
  'dice.no3d.toast.policy': 'Os dados 3D não aparecem: o 3D está bloqueado neste navegador.',
  'dice.no3d.toast.fix': 'Como ligar',
  'dice.no3d.toast.why': 'Ver por quê',
  'dice.effect.fire': 'Fogo',
  'dice.effect.ice': 'Gelo',
  'dice.effect.acid': 'Ácido',
  'dice.effect.stone': 'Pedra',
  'dice.effect.tavern': 'Taverna',
  'dice.effect.casino': 'Rich Akeime',
  'dice.effect.nature': 'Natureza',
  'dice.effect.divine': 'Luz divina',
  'dice.effect.lightning': 'Raio',
  'config.dice.body': 'Cor dos dados',
  'config.dice.number': 'Cor do número',
  'scene.undo': 'Desfazer (Ctrl+Z)',
  'scene.redo': 'Refazer (Ctrl+Y)',
  'scene.undo.stale': 'Não deu para desfazer: a cena mudou desde então.',
  'scene.token.copied': '"{name}" copiado. Ctrl+V cola onde está o mouse.',
  'scene.token.duplicate': 'Duplicar (Ctrl+D)',
  'settings.tab.game': 'Regras de jogo',
  'settings.tab.plugins': 'Plugins',
  'settings.game.none': 'Nenhuma',
  'settings.game.bars': 'Barrinhas dos cartões',
  'settings.game.bars.hint': 'As barras (vida, mana…) que aparecem no cartão de cada jogador. Os plugins das fichas preenchem os valores.',
  'settings.game.bars.count': 'Quantas barrinhas',
  'settings.game.bar.color': 'Cor da barrinha {n}',
  'settings.game.bar.color.reset': 'Usar a cor do plugin',
  'settings.game.bar.name': 'Nome da barrinha {n}',
  'settings.game.bar.numbers': 'Quem vê os números da barrinha {n}',
  'settings.game.bar.kind': 'Como mostrar os números da barrinha {n}',
  'settings.game.numbers.everyone': 'Números: todos veem',
  'settings.game.numbers.gmOwner': 'Números: mestres e dono',
  'settings.game.kind.values': 'Em valor / máximo',
  'settings.game.kind.percent': 'Em porcentagem',
  'settings.game.lines': 'Linhas dos cartões',
  'settings.game.lines.hint': 'Linhas de texto livre no cartão de cada jogador (condição, posição…). O nome aparece ao editar o cartão.',
  'settings.game.lines.count': 'Quantas linhas',
  'settings.game.line.name': 'Nome da linha {n}',
  'settings.game.dice': 'Dados',
  'settings.game.dice.animation': 'Animar os dados 3D',
  'settings.game.dice.animation.hint': 'Os dados rolam na tela de todos, e o resultado aparece no chat quando eles param. Desligado, ninguém na mesa vê a animação, e o resultado aparece na hora.',
  'settings.game.dice.source': 'Números dos dados',
  'settings.game.dice.program': 'Gerados pelo programa',
  'settings.game.dice.randomOrg': 'Aleatórios reais (random.org)',
  'settings.game.dice.hint': 'Vale para todas as rolagens da mesa. Com random.org, os números vêm de ruído atmosférico, e um R aparece ao lado da aba do chat. Se o random.org não estiver disponível, a rolagem sai pelo programa e o R fica riscado.',
  'settings.game.sessions': 'Sessões',
  'settings.game.sessions.hint': 'O relógio da sessão conta o tempo de jogo e guarda cada sessão na aba Sessões.',
  'settings.game.sessions.record': 'Registrar as sessões',
  'settings.game.sessions.record.hint': 'O relógio, as linhas no chat e a aba Sessões. Desligado, nada disso aparece, e as sessões de antes ficam guardadas.',
  'settings.game.sessions.chatClock': 'Relógio no chat',
  'settings.game.sessions.chatClock.hint': 'O tempo de jogo na faixa de abas do chat (no celular, embaixo do nome da mesa). Sem ele, o mestre controla a sessão pela aba Sessões.',
  'settings.game.sessions.barClock': 'Relógio no botão da mesa',
  'settings.game.sessions.barClock.hint': 'O anel em volta das iniciais da mesa, na barra da esquerda.',
  'settings.game.sessions.ending': 'A sessão {n} está em andamento: ao salvar, ela é encerrada.',
  'users.card.nothing': 'As regras de jogo desta mesa não mostram barrinhas nem linhas.',
  'users.card.barChange': '{bar} de {player}: {delta}',
  'users.card.maxDelta': 'máx.',
  'library.dock.erase': 'Apagar os dados guardados: {type}',
  'library.dock.erase.confirm': 'Os dados guardados da tabela "{type}" serão apagados de vez.',
  'library.dock.erase.go': 'Apagar',
  'macro.panel': 'Macros',
  'macro.manage': 'Gerenciar…',
  'macro.panel.empty': 'Nenhuma macro ainda. Crie em "Gerenciar…" ou com /macros no chat.',
  'scene.bg.pick': 'Imagem do mapa',
  'scene.bg.failed': 'Não deu para usar essa imagem como mapa: {message}',
  'room.popout': 'Abrir em nova janela',
  'room.popout.back': 'Devolver à mesa',
  'room.popout.blocked': 'O navegador bloqueou a nova janela. Libere as janelas pop-up deste site e tente de novo.',
  'room.popout.login': 'Entre no RPG Desk pela janela principal e abra a janela de novo.',
  'scene.tool.walls': 'Paredes (W)',
  'scene.walls.options': 'Opções das paredes',
  'scene.walls.mode.draw': 'Desenhar',
  'scene.walls.mode.select': 'Selecionar',
  'scene.walls.mode.cut': 'Remover com retângulo',
  'scene.walls.shape.line': 'Segmentos',
  'scene.walls.shape.rect': 'Retângulo',
  'scene.walls.shape.ellipse': 'Elipse',
  'scene.walls.shape.free': 'Mão livre',
  'scene.walls.snap': 'Encaixar na grade',
  'scene.walls.join': 'Unir pontas próximas',
  'scene.walls.join.hint': 'Junta no mesmo ponto as pontas que estão a menos de um quarto de célula de outra parede: das paredes selecionadas, ou de todas.',
  'scene.walls.join.done': 'Pontas unidas: {n}.',
  'scene.walls.join.none': 'Nenhuma ponta está perto o bastante de outra parede para unir.',
  'scene.walls.clear': 'Apagar todas as paredes',
  'scene.walls.clear.confirm': 'Apagar as {n} paredes desta cena? Dá para desfazer com Ctrl+Z.',
  'scene.walls.deleteSelected': 'Apagar selecionadas ({n})',
  'scene.walls.hint.line': 'Clique para pôr os pontos; perto do ponto de outra parede, ele encaixa nela. Duplo clique ou Enter termina; clicar no primeiro ponto fecha; Backspace tira o último; Esc cancela.',
  'scene.walls.hint.shape': 'Arraste para desenhar a forma.',
  'scene.walls.hint.select': 'Clique numa parede (Shift soma) ou arraste uma caixa. Arraste um vértice para movê-lo (perto do ponto de outra parede, ele encaixa). Delete apaga.',
  'scene.walls.hint.cut': 'Arraste um retângulo: o que estiver dentro dele sai das paredes.',
  'scene.viewAs': 'Ver a cena como',
  'scene.viewAs.gm': 'Mestre',
  'scene.viewAs.all': 'Todos os jogadores',
  'scene.vision': 'Visão dos tokens',
  'scene.vision.enabled': 'Visão dos tokens (os jogadores veem o que os tokens deles veem; as paredes cortam a visão)',
  'scene.vision.sharing': 'Compartilhamento',
  'scene.vision.sharing.individual': 'Visão individual',
  'scene.vision.sharing.group': 'Visão em grupo',
  'scene.token.vision': 'Visão',
  'scene.token.hasSight': 'Possui visão (NPC: conta em "Ver como" do mestre; o token de um jogador sempre dá visão a ele)',
  'scene.token.sightBright': 'Alcance sob luz intensa ({unit})',
  'scene.token.visionGmOnly': 'Só o mestre muda a visão e a luz do token.',
  'scene.walls.preset.wall': 'Parede',
  'scene.walls.preset.window': 'Janela',
  'scene.walls.preset.ethereal': 'Etérea',
  'scene.walls.preset.terrain': 'Terreno',
  'scene.walls.preset.door': 'Porta',
  'scene.walls.preset.secret': 'Porta secreta',
  'scene.walls.properties': 'Propriedades da parede',
  'scene.walls.propertiesButton': 'Propriedades…',
  'scene.walls.prop.many': 'Vale para as {n} paredes selecionadas.',
  'scene.walls.prop.type': 'Tipo',
  'scene.walls.prop.custom': 'Personalizada',
  'scene.walls.prop.move': 'Bloqueia o movimento',
  'scene.walls.prop.sight': 'Visão',
  'scene.walls.prop.sight.normal': 'Bloqueia',
  'scene.walls.prop.sight.limited': 'Limitada (terreno)',
  'scene.walls.prop.sight.none': 'Não bloqueia (janela)',
  'scene.walls.prop.dir': 'Direção',
  'scene.walls.prop.dir.both': 'Dos dois lados',
  'scene.walls.prop.dir.left': 'Só para quem está à esquerda',
  'scene.walls.prop.dir.right': 'Só para quem está à direita',
  'scene.walls.prop.door': 'Porta',
  'scene.walls.prop.door.none': 'Não é porta',
  'scene.walls.prop.door.door': 'Porta',
  'scene.walls.prop.door.secret': 'Porta secreta',
  'scene.walls.prop.state': 'Estado',
  'scene.walls.prop.state.closed': 'Fechada',
  'scene.walls.prop.state.open': 'Aberta',
  'scene.walls.prop.state.locked': 'Trancada',
  'scene.walls.prop.hint.terrain': 'Terreno: a visão passa pela primeira parede limitada e para na segunda. Contorne o objeto inteiro (a rocha, o pilar): quem olha vê o objeto, mas não o que está atrás dele.',
  'scene.walls.prop.hint.terrainOpen': 'Linha aberta: a visão cruza esta parede uma vez só e passa. Para esconder o que está atrás, feche o contorno (ao desenhar, clique no primeiro ponto) ou ponha outra parede limitada além dela.',
  'scene.walls.prop.hint.dir': 'Esquerda e direita contam indo do primeiro ponto para o segundo. A parede só vale para quem olha pelo lado escolhido; pelo outro lado, ela não existe.',
  'scene.walls.prop.doorTwoPoints': 'Só paredes de um segmento (2 pontos) viram porta.',
  'scene.door.open': 'Abrir a porta',
  'scene.door.close': 'Fechar a porta',
  'scene.door.locked': 'Porta trancada',
  'scene.door.locked.gm': 'Porta trancada: o botão direito destranca',
  'scene.door.isLocked': 'A porta está trancada.',
  'scene.ping.spectator': 'Espectadores não pingam no mapa. Peça ao mestre para virar jogador.',
  'scene.door.lockedNotice': '{name} tentou abrir uma porta trancada',
  'scene.token.addToCombat': 'Adicionar ao combate',
  'scene.token.addToCombat.hint': 'Põe o token no tracker de combate, ligado a ele: invisível, o token some do combate para quem não o vê',
  'scene.token.inCombat': 'Já está no combate',
  'scene.token.addedToCombat': '{name} entrou no combate',
  'scene.token.conditions': 'Condições',
  'scene.token.conditionsHint': 'Todos na mesa veem os ícones no token. Quem continua vendo o token invisível se escolhe no menu do token, em Condições › Invisível….',
  'scene.cond.blind': 'Cego',
  'scene.cond.dead': 'Morto',
  'scene.cond.poisoned': 'Envenenado',
  'scene.cond.stunned': 'Atordoado',
  'scene.cond.paralyzed': 'Paralisado',
  'scene.cond.prone': 'Caído',
  'scene.cond.frightened': 'Amedrontado',
  'scene.cond.unconscious': 'Inconsciente',
  'scene.cond.bleeding': 'Sangrando',
  'scene.token.invisible': 'Invisível…',
  'scene.token.invisible.on': 'Invisível (ligado)…',
  'scene.token.invisible.hint': 'Só o mestre, quem controla o token e quem você liberar o veem',
  'scene.invisible.title': 'Invisível: {name}',
  'scene.invisible.on': 'Deixar o token invisível',
  'scene.invisible.viewers': 'Quem continua vendo',
  'scene.invisible.always': 'O mestre e quem controla o token sempre o veem. Quem não for marcado não vê nada dele: imagem, nome e barra.',
  'scene.invisible.nobody': 'Não há mais ninguém na mesa agora.',
  'scene.invisible.away': 'Alguém fora da mesa',
  'scene.invisible.badge': 'Invisível',
  'scene.invisible.notice.on': '{name} deixou {token} invisível',
  'scene.invisible.notice.viewers': '{name} mudou quem vê {token}',
  'scene.invisible.notice.off': '{name} tirou o invisível de {token}',
  'scene.tool.semi': 'Área parcialmente visível',
  'scene.tool.semi.hint': 'Aparece esmaecida.',
  'scene.tool.explore': 'Área à explorar',
  'scene.tool.explore.hint': 'Volta ao padrão: oculta até ser vista.',
  'scene.vision.resetMemory': 'Reiniciar a exploração',
  'scene.vision.resetMemory.confirm': 'Apagar o que todos os tokens já viram? O mapa volta a ficar oculto onde ninguém está vendo agora.',
  'scene.token.sightDim': 'Alcance sob luz fraca ({unit})',
  'scene.token.sightDark': 'Visão no escuro ({unit})',
  'scene.token.lightBright': 'Luz intensa que emite ({unit})',
  'scene.token.lightDim': 'Luz fraca que emite ({unit})',
  'scene.token.lightOnly': 'Só luz (os jogadores não veem o token, só a luz dele)',
  'scene.token.rangesHint': 'Alcance 0 é não ver naquela luz. Padrão: 102 sob luz intensa, 1,5 sob luz fraca e 0 de visão no escuro. A visão no escuro enxerga sem luz nenhuma, o mapa e os tokens, e o que ela mostra aparece sem cor e mais escuro.',
  'scene.aura': 'Aura',
  'scene.aura.has': 'Possui aura',
  'scene.aura.shape': 'Formato',
  'scene.aura.shape.circle': 'Círculo',
  'scene.aura.shape.cone': 'Cone',
  'scene.aura.shape.semicircle': 'Semicírculo',
  'scene.aura.shape.rect': 'Retângulo',
  'scene.aura.shape.image': 'Imagem',
  'scene.aura.reach': 'Alcance ({unit})',
  'scene.aura.reachHint': 'Contado a partir da borda do token: uma aura de 3 m pega tudo a até 3 m dele, e cresce junto com o token. O cone e o semicírculo medem o comprimento à frente.',
  'scene.aura.angle': 'Abertura (graus)',
  'scene.aura.width': 'Largura ({unit})',
  'scene.aura.height': 'Altura ({unit})',
  'scene.aura.color': 'Cor da aura',
  'scene.aura.opacity': 'Opacidade',
  'scene.aura.grid': 'Em quadrados (pinta as células da grade)',
  'scene.aura.image': 'Escolher imagem…',
  'scene.aura.image.pick': 'Imagem da aura',
  'scene.aura.image.missing': 'Escolha a imagem da aura.',
  'scene.aura.hint': 'A aura anda e gira com o token: o cone e o semicírculo apontam para a direção dele (Girar 45° no botão direito, ou Shift + roda). Quem vê o token vê a aura.',
  'scene.vision.ambient': 'Luz ambiente',
  'scene.vision.ambient.intense': 'Luz intensa / Sol',
  'scene.vision.ambient.weak': 'Luz fraca / Penumbra',
  'scene.vision.ambient.none': 'Nenhuma / Escuridão',
  'scene.token.turnLeft': 'Girar 45° para a esquerda',
  'scene.token.turnRight': 'Girar 45° para a direita',
  'scene.token.turnHint': 'Shift + roda gira de 15 em 15',
  'scene.token.angle': 'Ângulo da visão (graus)',
  'scene.token.lightAngle': 'Ângulo da luz (graus)',
  'scene.token.facingMode': 'Direção',
  'scene.token.facingMode.rotate': 'Girar a imagem',
  'scene.token.facingMode.arrow': 'Mostrar uma seta',
  'scene.uvtt.import': 'Importar mapa UVTT…',
  'scene.uvtt.light': 'Luz',
  'scene.uvtt.done': 'Mapa importado: {walls} paredes, {doors} portas e {lights} luzes. A névoa e a visão dos tokens foram ligadas.',
  'scene.uvtt.failed': 'Não deu para importar o mapa: {message}',
  'scene.uvtt.tooBig': 'O arquivo do mapa passa de {size}.',
  'scene.uvtt.imageTooBig': 'A imagem do mapa passa de {size}, o limite do seu plano.',
  'scene.tool.select.hint': 'Clique num token para selecioná-lo; arraste para movê-lo. Arrastar o mapa vazio move a vista. Alt + clique (ou segurar parado) faz um ping para todos.',
  'scene.tool.pan.hint': 'Só move a vista: o arrasto passa por cima dos tokens, sem selecionar nem mover nenhum. Em qualquer ferramenta, o botão do meio ou o direito do mouse também arrastam a vista.',
  'webPlugin.loading.sheet': 'Abrindo a ficha…',
  'webPlugin.loading.table': 'Abrindo a tabela…',
  'webPlugin.timeout': 'A página não respondeu. Ela carrega o rpgdesk.js?',
  'webPlugin.navigated': 'A página tentou sair para outro endereço e foi fechada.',
  'webPlugin.hung': 'A página parou de responder.',
  'webPlugin.reload': 'Recarregar',
  'webPlugin.close': 'Fechar',
  'webPlugin.reopen': 'Abrir de novo',
  'webPlugin.noEntry': 'O plugin não tem a página desta ficha.',
  'webPlugin.dev': 'Desenvolvimento: {url}',
  'webPlugin.errors.title': 'Erros da página',
  'webPlugin.errors.copy': 'Copiar erros',
  'webPlugin.errors.clear': 'Limpar',
  'webPlugin.errors.copied': 'Erros copiados. Cole na conversa com a IA ou com quem fez o plugin.',
  'webPlugin.link.title': 'Abrir site',
  'webPlugin.link.message': 'O plugin "{plugin}" quer abrir {url} numa nova aba.',
  'webPlugin.link.go': 'Abrir',
  'webPlugin.aiGuide': 'Copiar instruções para IA',
  'webPlugin.aiGuide.hint': 'Copia o guia de como fazer fichas e tabelas para o RPG Desk. Cole no começo da conversa com a IA e descreva a sua ficha.',
  'webPlugin.aiGuide.copied': 'Instruções copiadas. Cole no começo da conversa com a IA e descreva a ficha que você quer.',
  'webPlugin.hooks': 'Integrações ({count})',
  'webPlugin.hooks.hint': 'O plugin pode mandar dados para os webhooks abaixo. Cole o endereço do webhook (Zapier, Make ou IFTTT). Os endereços ficam só no servidor; os jogadores não os veem.',
  'webPlugin.hooks.url': 'Endereço do webhook {name}',
  'webPlugin.hooks.who': 'Quem pode disparar {name}',
  'webPlugin.hooks.gm': 'Só mestres',
  'webPlugin.hooks.everyone': 'Todos',
  'webPlugin.hooks.save': 'Salvar',
  'webPlugin.hooks.remove': 'Remover',
  'webPlugin.hooks.on': 'Ligado.',
  'webPlugin.hooks.off': 'Desligado: sem endereço.',
  'webPlugin.hooks.log': 'Últimos envios',
  'webPlugin.devmode': 'Desenvolvimento',
  'webPlugin.devmode.hint': 'Carrega a ficha ou tabela de um endereço do seu computador (por exemplo, o servidor de desenvolvimento do seu projeto). Vale só neste navegador; os outros na mesa continuam com a versão instalada.',
  'webPlugin.devmode.url': 'Endereço de desenvolvimento de {title}',
  'webPlugin.devmode.off': 'Desligar',
  'webInstall.title': 'Instalar plugin',
  'webInstall.issues': 'Problemas encontrados',
  'webInstall.error': 'Erro',
  'webInstall.warning': 'Aviso',
  'webInstall.fix': 'Como consertar: {fix}',
  'webInstall.copy': 'Copiar relatório',
  'webInstall.copied': 'Relatório copiado. Cole na conversa com a IA para ela consertar.',
  'webInstall.installing': 'Instalando…',
  'webInstall.install': 'Instalar',
  'webInstall.update': 'Atualizar',
  'webInstall.by': 'por {author}',
  'webInstall.updating': 'Atualiza a versão {from} instalada para {to}. As fichas mantêm os dados.',
  'webInstall.downgrade': 'A versão {to} é menor que a {from} instalada.',
  'webInstall.sheet': 'Ficha: {title}',
  'webInstall.table': 'Tabela da sala: {title}',
  'webInstall.webhooks': 'Pode mandar dados para fora, pelos webhooks que você cadastrar depois em Integrações:',
  'webInstall.unreadable': 'Não deu para ler o plugin em "{file}".',
  'webInstall.hasErrors': 'Com erros, o plugin não é instalado. Copie o relatório e leve à IA ou a quem fez o plugin.',
  'webInstall.cloudFailed': 'Não deu para baixar "{file}" do Desk Cloud.',
  'webInstall.noRoom': 'Entre numa mesa antes de instalar.',
  'webInstall.failed': 'O servidor não instalou o plugin.',
  'pluginInstall.tabs': 'De onde vem o plugin',
  'pluginInstall.tab.official': 'Oficiais',
  'pluginInstall.tab.cloud': 'Desk Cloud',
  'pluginInstall.tab.computer': 'Computador',
  'pluginInstall.official.forSystem': 'Para {system}',
  'pluginInstall.official.others': 'Outros',
  'pluginInstall.official.none': 'Ainda não há plugins oficiais',
  'pluginInstall.official.noneText': 'Instale um plugin do seu Desk Cloud ou do computador.',
  'pluginInstall.official.failed': 'Não deu para carregar os plugins oficiais: {message}',
  'pluginInstall.retry': 'Tentar de novo',
  'pluginInstall.installed': 'Instalado',
  'pluginInstall.installLabel': 'Instalar {name}',
  'pluginInstall.updateTo': 'Atualizar para {version}',
  'pluginInstall.updateLabel': 'Atualizar {name} para a versão {version}',
  'pluginInstall.updateTitle': 'Atualizar {name} para a versão {version}',
  'pluginInstall.kind.sheet': 'Ficha',
  'pluginInstall.kind.sheets': '{n} fichas',
  'pluginInstall.kind.table': 'Tabela da mesa',
  'pluginInstall.kind.tables': '{n} tabelas da mesa',
  'pluginInstall.cloud.empty': 'Nenhum pacote de plugin (.zip ou .html) no seu Desk Cloud.',
  'pluginInstall.cloud.package': 'Pacote',
  'pluginInstall.cloud.hint': 'Só aparecem pacotes .zip e .html. Um .zip instala direto, sem cópia nova no Desk Cloud.',
  'pluginInstall.cloud.continue': 'Continuar',
  'pluginInstall.computer.drop': 'Solte aqui o .zip ou o .html do plugin',
  'pluginInstall.computer.pick': 'Escolha o .zip ou o .html do plugin',
  'pluginInstall.computer.choose': 'Escolher arquivo…',
  'pluginInstall.computer.hint': 'O RPG Desk confere o pacote antes de instalar. Ele fica no seu Desk Cloud, ligado à mesa.',
  'pluginInstall.reading': 'Conferindo…',
  'webPlugin.errors.button': 'Erros da página ({count})',
  'webPlugin.errors.reportSheet': 'Erros da ficha "{name}" (plugin {plugin})',
  'webPlugin.errors.reportTable': 'Erros da tabela "{name}" (plugin {plugin})',

  // área de administração (docs/spec/admin.md)
  'logged.nav.admin': 'Administração',
  'signedOut.suspended.title': 'Conta suspensa',
  'signedOut.suspended.text': 'Um administrador suspendeu a sua conta. Enquanto ela estiver suspensa, não dá para entrar.',
  'signedOut.password.title': 'Senha trocada',
  'signedOut.password.text': 'Um administrador trocou a sua senha. Entre com a senha nova que ele passou para você.',
  'signedOut.deleted.title': 'Conta apagada',
  'signedOut.deleted.text': 'Um administrador apagou a sua conta.',
  'signedOut.reason': 'Motivo: {reason}',
  'admin.title': 'Administração',
  'admin.section.overview': 'Visão geral',
  'admin.section.users': 'Usuários',
  'admin.section.plans': 'Planos',
  'admin.section.rooms': 'Mesas',
  'admin.section.plugins': 'Plugins oficiais',
  'admin.section.server': 'Servidor',
  'admin.section.log': 'Registro',
  'admin.overview.accounts': 'Contas',
  'admin.overview.total': 'Todas as contas',
  'admin.overview.newLastWeek': 'novas na semana: {n}',
  'admin.overview.online': 'Online agora',
  'admin.overview.suspended': 'Suspensas',
  'admin.overview.admins': 'Administradores',
  'admin.overview.plans': 'Contas por plano',
  'admin.overview.server': 'Servidor',
  'admin.overview.space': 'Espaço usado',
  'admin.overview.files': 'arquivos: {n}',
  'admin.overview.rooms': 'Mesas',
  'admin.overview.activeRooms': 'com gente agora: {n}',
  'admin.overview.uploads': 'Envios em leitura',
  'admin.overview.uploadsLimit': 'teto de {limit}',
  'admin.rooms.search': 'Buscar pela mesa ou pelo dono',
  'admin.rooms.sort': 'Ordem',
  'admin.rooms.sort.recent': 'Mais recentes',
  'admin.rooms.sort.name': 'Nome',
  'admin.rooms.sort.members': 'Mais membros',
  'admin.rooms.sort.space': 'Mais espaço',
  'admin.rooms.count': 'Mesas encontradas: {n}',
  'admin.rooms.none': 'Nenhuma mesa com essa busca.',
  'admin.rooms.col.room': 'Mesa',
  'admin.rooms.col.owner': 'Dono',
  'admin.rooms.col.members': 'Membros',
  'admin.rooms.col.online': 'Agora',
  'admin.rooms.col.files': 'Arquivos',
  'admin.rooms.col.created': 'Criada',
  'admin.rooms.col.last': 'Última mensagem',
  'admin.rooms.filesValue': '{n} · {size}',
  'admin.rooms.private': 'Privada',
  'admin.rooms.password': 'Senha',
  'admin.rooms.never': 'nunca',
  'admin.rooms.more': 'Ações para {name}',
  'admin.rooms.openOwner': 'Ver o dono',
  'admin.rooms.delete': 'Apagar mesa',
  'admin.rooms.deleteTitle': 'Apagar a mesa {name}',
  'admin.rooms.deleteLabel': 'Digite o nome da mesa ({name}) para confirmar. A mesa, as fichas, a cena, o chat e os arquivos dela saem para sempre, e quem estiver nela sai na hora.',
  'admin.rooms.deleteDone': 'A mesa {name} foi apagada.',
  'admin.rooms.deleteMismatch': 'O nome digitado não é o da mesa.',
  'admin.roomDelete.detail': 'Mesa: {name}',
  'admin.server.hint': 'Tudo aqui muda no apps/server/.env (veja o .env.example), com o servidor reiniciado.',
  'admin.server.running': 'No ar',
  'admin.server.version': 'Versão do RPG Desk',
  'admin.server.node': 'Node',
  'admin.server.startedAt': 'No ar desde',
  'admin.server.limits': 'Limites',
  'admin.server.maxUpload': 'Teto de um arquivo',
  'admin.server.uploadMemory': 'Memória dos envios',
  'admin.server.inUseOf': '{used} em uso, de {limit}',
  'admin.server.maxBody': 'Maior pedido em JSON',
  'admin.server.history': 'Histórico ao entrar na mesa',
  'admin.server.messages': '{n} mensagens',
  'admin.server.access': 'Acesso e serviços',
  'admin.server.admins': 'Administradores da configuração',
  'admin.server.cors': 'Endereços da interface hospedada à parte',
  'admin.server.plugins': 'Endereço dos plugins',
  'admin.server.samePlace': 'o deste servidor (/p)',
  'admin.server.storage': 'Pasta do bucket',
  'admin.server.randomOrg': 'Dados do random.org',
  'admin.server.client': 'Serve a interface',
  'admin.server.on': 'Sim',
  'admin.server.off': 'Não',
  'admin.server.none': 'nenhum',
  'admin.tab.users': 'Usuários',
  'admin.tab.log': 'Registro',
  'admin.users.search': 'Buscar por nome ou e-mail',
  'admin.users.filter': 'Mostrar',
  'admin.users.filter.all': 'Todas',
  'admin.users.filter.online': 'Online',
  'admin.users.filter.admins': 'Administradores',
  'admin.users.filter.suspended': 'Suspensas',
  'admin.users.sort': 'Ordem',
  'admin.users.sort.recent': 'Mais recentes',
  'admin.users.sort.name': 'Nome',
  'admin.users.sort.seen': 'Visto por último',
  'admin.users.plan': 'Plano',
  'admin.users.plan.all': 'Todos os planos',
  'admin.users.plan.paid': 'Planos pagos',
  'admin.users.count': 'Contas encontradas: {n}',
  'admin.users.none': 'Nenhuma conta com essa busca.',
  'admin.col.account': 'Conta',
  'admin.col.email': 'E-mail',
  'admin.col.created': 'Criada em',
  'admin.col.seen': 'Visto por último',
  'admin.col.rooms': 'Mesas',
  'admin.col.space': 'Espaço',
  'admin.col.plan': 'Plano',
  'admin.more': 'Ações para {name}',
  'admin.details': 'Ver detalhes',
  'admin.loadMore': 'Carregar mais',
  'admin.online': 'Online agora',
  'admin.neverSeen': 'Nunca conectou',
  'admin.badge.admin': 'Admin',
  'admin.badge.admin.env': 'Administradora pela configuração do servidor (RPGDESK_ADMINS)',
  'admin.badge.admin.db': 'Promovida a administradora na tela',
  'admin.badge.suspended': 'Suspensa',
  'admin.action.suspend': 'Suspender',
  'admin.action.unsuspend': 'Reativar',
  'admin.action.password': 'Senha provisória',
  'admin.action.promote': 'Tornar admin',
  'admin.action.demote': 'Tirar de admin',
  'admin.action.delete': 'Apagar conta',
  'admin.action.plan': 'Mudar plano',
  'admin.refusal.self': 'Não vale para a sua própria conta',
  'admin.refusal.configured': 'Administradora pela configuração do servidor: muda só por lá',
  'admin.refusal.admin': 'Tire o papel de administrador antes',
  'admin.refusal.suspended': 'Reative a conta antes',
  'admin.suspend.title': 'Suspender {name}',
  'admin.suspend.label': 'Motivo (a pessoa vê ao tentar entrar). As sessões abertas dela caem na hora.',
  'admin.suspend.done': '{name} foi suspensa.',
  'admin.unsuspend.confirm': '{name} volta a poder entrar.',
  'admin.unsuspend.done': '{name} foi reativada.',
  'admin.password.title': 'Senha provisória de {name}',
  'admin.password.label': 'Copie a senha para passar à pessoa (ou escreva outra). As sessões abertas dela caem, e ela entra com esta.',
  'admin.password.action': 'Trocar a senha',
  'admin.password.done': 'A senha de {name} foi trocada.',
  'admin.password.doneCopied': 'A senha de {name} foi trocada e copiada.',
  'admin.promote.confirm': '{name} passa a ver a área de administração e a poder agir nas outras contas.',
  'admin.promote.done': '{name} agora é administradora.',
  'admin.demote.confirm': '{name} deixa de ver a área de administração.',
  'admin.demote.done': '{name} não é mais administradora.',
  'admin.delete.title': 'Apagar {name}',
  'admin.delete.label': 'A conta, as mesas dela, os arquivos e as mensagens saem para sempre. Para confirmar, digite o nome da conta: {name}',
  'admin.delete.mismatch': 'O nome digitado não é o da conta.',
  'admin.delete.done': 'A conta {name} foi apagada.',
  'admin.plan.title': 'Mudar o plano de {name}',
  'admin.plan.plan': 'Plano',
  'admin.plan.noExpiry': 'Sem prazo',
  'admin.plan.validUntil': 'Vale até',
  'admin.plan.note': 'Nota interna (só os administradores veem)',
  'admin.plan.freeNoExpiry': 'O Grátis não tem prazo.',
  'admin.plan.same': 'A conta já está nesse plano, com esse prazo.',
  'admin.plan.overUse': 'A conta usa {used}, e o {plan} dá {space}. Ela não envia arquivos novos até liberar espaço; nada é apagado.',
  'admin.plan.done': 'Plano de {name}: {plan}.',
  'admin.plan.until': 'até {date}',
  'admin.plan.expiredOn': '{plan} venceu em {date}',
  'admin.plan.noExpiryShort': 'sem prazo',
  'admin.plan.grantedBy': 'dado por {name}',
  'admin.log.empty': 'Nenhuma ação de administrador ainda.',
  'admin.log.col.when': 'Quando',
  'admin.log.col.admin': 'Quem',
  'admin.log.col.action': 'Ação',
  'admin.log.col.target': 'Conta',
  'admin.log.col.detail': 'Detalhe',
  'admin.log.suspend': 'Suspendeu',
  'admin.log.unsuspend': 'Reativou',
  'admin.log.password': 'Trocou a senha',
  'admin.log.delete': 'Apagou a conta',
  'admin.log.promote': 'Tornou admin',
  'admin.log.demote': 'Tirou de admin',
  'admin.log.plan': 'Mudou o plano',
  'admin.log.plan-config': 'Editou o plano',
  'admin.log.room-delete': 'Apagou a mesa',
  'admin.log.plugin-add': 'Publicou o plugin',
  'admin.log.plugin-version': 'Publicou versão nova',
  'admin.log.plugin-systems': 'Mudou os sistemas',
  'admin.log.plugin-hide': 'Ocultou do catálogo',
  'admin.log.plugin-show': 'Voltou ao catálogo',
  'admin.log.plugin-delete': 'Apagou o plugin',
  'admin.planConfig.reset': 'Voltou ao padrão',
  'admin.planConfig.name.pt': 'Nome (pt)',
  'admin.planConfig.name.en': 'Nome (en)',
  'admin.planConfig.price': 'Preço',
  'admin.plans.hint': 'O que você grava vale na hora para todas as contas do plano. Nada é apagado: quem passar do espaço só não envia arquivos novos.',
  'admin.plans.readOnly': 'Só os administradores da configuração do servidor (RPGDESK_ADMINS) mudam os planos. Aqui você vê, sem editar.',
  'admin.plugins.hint': 'Os mestres instalam estes plugins pela aba Oficiais de "Instalar plugin…". Uma versão nova não muda as mesas: cada mestre atualiza quando quiser.',
  'admin.plugins.readOnly': 'Só os administradores da configuração do servidor (RPGDESK_ADMINS) mudam os plugins oficiais. Aqui você vê, sem editar.',
  'admin.plugins.add': 'Adicionar plugin…',
  'admin.plugins.none': 'Nenhum plugin oficial',
  'admin.plugins.noneText': 'Os plugins cadastrados aqui aparecem para todos os mestres na aba Oficiais de "Instalar plugin…".',
  'admin.plugins.count': 'Plugins: {n}',
  'admin.plugins.col.plugin': 'Plugin',
  'admin.plugins.col.version': 'Versão',
  'admin.plugins.col.contents': 'Conteúdo',
  'admin.plugins.col.systems': 'Sistemas',
  'admin.plugins.col.usage': 'Mesas',
  'admin.plugins.col.updated': 'Publicada',
  'admin.plugins.roomsOutdated': '{n} · {old} em versão antiga',
  'admin.plugins.updatedBy': 'Publicada por {name}',
  'admin.plugins.noSystems': 'Nenhum',
  'admin.plugins.hiddenTag': 'Oculto',
  'admin.plugins.more': 'Ações para {name}',
  'admin.plugins.newVersion': 'Enviar versão nova…',
  'admin.plugins.editSystems': 'Sistemas…',
  'admin.plugins.hide': 'Ocultar do catálogo',
  'admin.plugins.hideHint': 'As mesas que já têm o plugin continuam com ele',
  'admin.plugins.show': 'Mostrar no catálogo',
  'admin.plugins.hiddenDone': '{name} saiu do catálogo.',
  'admin.plugins.shownDone': '{name} voltou ao catálogo.',
  'admin.plugins.delete': 'Apagar',
  'admin.plugins.deleteInUse': 'Instalado em mesas ({n}): oculte em vez de apagar',
  'admin.plugins.deleteTitle': 'Apagar o plugin {name}',
  'admin.plugins.deleteText': 'O plugin sai do catálogo com todas as versões publicadas. Nenhuma mesa o usa agora.',
  'admin.plugins.deleteDone': '{name} foi apagado.',
  'admin.plugins.addTitle': 'Adicionar plugin oficial',
  'admin.plugins.newVersionTitle': 'Versão nova de {name}',
  'admin.plugins.computerHint': 'O pacote é conferido antes de publicar e fica no servidor, fora do seu Desk Cloud.',
  'admin.plugins.cloudHint': 'Só aparecem pacotes .zip e .html. Publicar faz uma cópia no servidor: o arquivo do seu Desk Cloud pode sair depois.',
  'admin.plugins.isNew': 'Plugin novo no catálogo.',
  'admin.plugins.versionUp': 'Versão nova de {name}: {from} → {to}. As mesas ficam na versão delas até o mestre atualizar.',
  'admin.plugins.versionChange': '{from} → {to}. As mesas ficam na versão delas até o mestre atualizar.',
  'admin.plugins.sameVersion': 'A versão {version} já foi publicada. Aumente a versão no manifest.json.',
  'admin.plugins.older': 'A versão publicada é {version}. Envie uma versão maior.',
  'admin.plugins.otherPlugin': 'Este pacote é de outro plugin: a versão nova precisa ter o id {id}.',
  'admin.plugins.systemsLabel': 'Sistemas',
  'admin.plugins.systemsHint': 'Nas mesas destes sistemas, o plugin aparece no alto da aba Oficiais.',
  'admin.plugins.systemPlaceholder': 'Digite um sistema e Enter',
  'admin.plugins.systemsFull': 'Limite de sistemas atingido',
  'admin.plugins.addSystem': 'Adicionar',
  'admin.plugins.removeSystem': 'Tirar {system}',
  'admin.plugins.roomSystems': 'Nas mesas:',
  'admin.plugins.addKnown': 'Adicionar {system} (mesas: {n})',
  'admin.plugins.visibleNow': 'Mostrar no catálogo agora',
  'admin.plugins.publish': 'Publicar',
  'admin.plugins.addDone': '{name} está no catálogo.',
  'admin.plugins.versionDone': '{name} {version} publicado.',
  'admin.plugins.systemsTitle': 'Sistemas de {name}',
  'admin.plugins.systemsDone': 'Os sistemas de {name} mudaram.',
  'admin.plugins.save': 'Salvar',
  'admin.plugins.logSystems': 'Sistemas: {systems}',
  'admin.plugins.logNoSystems': 'Sem sistemas',
  'admin.plans.price': 'Preço por mês',
  'admin.plans.accounts': 'Contas no plano',
  'admin.plans.overSpace': 'Acima do espaço',
  'admin.plans.cut': '{value} (o servidor corta em {holds})',
  'admin.plans.edit': 'Editar',
  'admin.plans.reset': 'Voltar ao padrão',
  'admin.plans.resetConfirm': 'O {plan} volta ao espaço, ao maior arquivo, ao nome e ao preço do código. Vale na hora para todas as contas dele.',
  'admin.plans.resetDone': 'O {plan} voltou ao padrão.',
  'admin.plans.edited': 'Editado',
  'admin.plans.editedBy': 'Editado por {name}',
  'admin.plans.editTitle': 'Editar o {plan}',
  'admin.plans.save': 'Gravar',
  'admin.plans.saved': 'O {plan} foi gravado.',
  'admin.plans.namePt': 'Nome em português',
  'admin.plans.nameEn': 'Nome em inglês',
  'admin.plans.priceLabel': 'Preço por mês (R$)',
  'admin.plans.freeNoPrice': 'O Grátis não tem preço',
  'admin.plans.unit': 'Unidade de {what}',
  'admin.plans.range': 'Use um valor entre {min} e {max}.',
  'admin.plans.overCeiling': 'Acima do teto do servidor: vale {ceiling} até o teto subir (RPGDESK_MAX_UPLOAD_BYTES).',
  'admin.plans.badPrice': 'Preço inválido: use reais, com até dois centavos (7 ou 7,50).',
  'admin.plans.nesting': '{what}: o {plan} ficaria com menos que o {below}. Um plano não pode dar menos que o plano abaixo dele.',
  'admin.plans.impact': 'Contas deste plano que passam do espaço novo: {n}. Elas não enviam arquivos novos até liberar espaço; nada é apagado.',
  'admin.plans.unchanged': 'Nada mudou.',
  'admin.log.gone': 'A conta não existe mais',
  'admin.panel.label': 'Detalhes de {name}',
  'admin.panel.close': 'Fechar os detalhes',
  'admin.panel.suspendedBy': 'Suspensa por {name} em {date}',
  'admin.panel.reason': 'Motivo: {reason}',
  'admin.panel.noReason': 'Sem motivo informado.',
  'admin.panel.created': 'Conta criada',
  'admin.panel.lastLogin': 'Última entrada',
  'admin.panel.sessions': 'Sessões abertas',
  'admin.panel.tos': 'Termos de uso',
  'admin.panel.tosAccepted': 'Versão {version}, aceitos em {date}',
  'admin.panel.tosNone': 'Não aceitos',
  'admin.panel.space': '{used} de {quota} · arquivos: {files}',
  'admin.panel.friends': 'Amigos',
  'admin.panel.rooms': 'Mesas que criou ({n})',
  'admin.panel.noRooms': 'Nenhuma mesa.',
  'admin.panel.history': 'Histórico de administração',
  'admin.panel.noHistory': 'Nenhuma ação de administrador nesta conta.',

  /* planos (docs/spec/planos.md) */
  'plans.name.free': 'Grátis',
  'plans.name.tier1': 'Plano 1',
  'plans.name.tier2': 'Plano 2',
  'plans.name.tier3': 'Plano 3',
  'plans.entitlement.storageBytes': 'Espaço',
  'plans.entitlement.maxFileBytes': 'Maior arquivo',
  'plans.short.storageBytes': '{value}',
  'plans.short.maxFileBytes': 'arquivos até {value}',
  'plans.unlimited': 'sem limite',
  'plans.yes': 'Sim',
  'plans.no': 'Não',
  'plans.from': 'A partir do {plan}',
  'plans.full': 'Espaço cheio: apague arquivos ou mude de plano',
  'plans.noPrice': 'sem preço',
  'plans.upload.tooLarge': 'O arquivo passa de {size}, o limite do seu plano.',
  'plans.upload.noSpace': 'Não cabe no seu espaço: apague arquivos ou mude de plano.',
  'landing.nav': 'Navegação do site',
  'landing.nav.credits': 'Ficha técnica',
  'landing.nav.plans': 'Planos',
  'landing.nav.docs': 'Documentação',
  'landing.beta': 'Beta',
  'landing.beta.hint': 'O RPG Desk é um projeto em desenvolvimento.',
  'landing.signIn': 'Entrar',
  'landing.signUp.short': 'Criar conta',
  'landing.newTab': '(abre em nova aba)',
  'landing.back': 'Conhecer o RPG Desk',
  'landing.hero.title': 'O seu grupo joga aqui. Toda semana.',
  'landing.hero.text': 'Mapa com névoa e luz por token, dados 3D que caem para todos, fichas, voz e o diário da campanha. No navegador, sem instalar nada, de graça.',
  'landing.hero.gm': 'Criar minha mesa — grátis',
  'landing.hero.player': 'Vou jogar: achar uma mesa',
  'landing.live.label': 'Sessão de exemplo: A Cripta de Valdren',
  'landing.live.camera.gm': 'Câmera do mestre',
  'landing.live.camera.player': 'Câmera da Aria',
  'landing.live.sample': 'Sessão de exemplo',
  'landing.live.show': 'A Cripta de Valdren · sessão 12',
  'landing.live.clock': 'A sua hora',
  'landing.live.viewAs': 'Ver como',
  'landing.live.viewAs.gm': 'Mestre',
  'landing.live.viewAs.player': 'Aria (jogadora)',
  'landing.live.fogHint': 'Arraste a Aria: a névoa se abre por onde ela passa.',
  'landing.live.token': 'Token da Aria. Use as setas para mover.',
  'landing.live.skeleton': 'Esqueleto',
  'landing.live.table': 'Na mesa',
  'landing.live.people': '{count} pessoas',
  'landing.live.speaking': 'Falando',
  'landing.live.role.gm': 'Mestre',
  'landing.live.role.spectator': 'Espectador',
  'landing.live.now': 'Agora',
  'landing.live.events': 'Marina: As tochas tremem. Algo se mexe atrás das colunas…\nAria rolou 1d20+5 = 17 e acertou o esqueleto\nBram: Eu fico na porta. Ninguém passa.\nTeo entrou na mesa pelo link\nMarina pôs para tocar a trilha Combate\nAria mandou uma mensagem privada para a mestre',
  'landing.tray.title': 'Role você',
  'landing.tray.note': 'A mesma física e os mesmos efeitos da mesa',
  'landing.tray.effect': 'Efeito',
  'landing.tray.noEffect': 'Sem efeito',
  'landing.tray.roll': 'Rolar 1d20',
  'landing.tray.rolling': 'Rolando…',
  'landing.tray.you': 'Você · 1d20',
  'landing.tray.sample1': 'Aria · 1d20+5 · ataque',
  'landing.tray.sample2': 'Esqueleto · 1d6 · dano',
  'landing.tray.sample3': 'Bram · 1d20+3 · ataque',
  'landing.tray.no3d': 'Sem aceleração gráfica, o dado aparece parado, com o mesmo sorteio.',
  'landing.tray.failed': 'Os dados 3D falharam neste navegador. O sorteio continua valendo.',
  'landing.tray.result': 'Saiu {value}',
  'landing.seg.zero.time': 'Sessão 0',
  'landing.seg.zero.label': 'Fichas',
  'landing.seg.zero.title': 'A ficha do seu sistema, pronta ou feita por você.',
  'landing.seg.zero.text': 'Na sessão zero, o grupo cria os personagens. No RPG Desk, uma ficha é uma página web: instale uma oficial com um clique, peça uma a uma IA ou escreva a sua em HTML, mesmo sem saber programar.',
  'landing.seg.zero.items': 'Oficiais — A D&D 5e, a Ficha Básica e as outras fichas do RPG Desk: em Configurações da mesa → Plugins → Instalar plugin…, aba Oficiais, com as do sistema da mesa no alto\nCom IA — O botão Copiar instruções para IA leva o guia; descreva a ficha do seu sistema e instale o arquivo que a IA devolver\nEm HTML — Um campo é um data-field, uma rolagem é um data-roll; JavaScript só se você quiser\nDuas línguas — A mesma ficha em português e em inglês, com a tradução ao lado do texto, sem programar a troca\nPor mesa — Cada mesa instala as fichas e as tabelas que usa, dos Oficiais, do Desk Cloud ou do computador, e o mestre atualiza quando quiser\nAo vivo — A ficha grava enquanto você digita, e a mesa vê na hora\nPartes do mestre — O que é só do mestre nem chega ao navegador dos jogadores',
  'landing.seg.zero.dnd': 'D&D 5e',
  'landing.seg.zero.credits': 'A D&D 5e é uma ficha oficial do RPG Desk, nas duas línguas e com as regras do SRD 5.1 (CC BY 4.0): na mesa, ela está na aba Oficiais.',
  'landing.seg.zero.open': 'Ver a D&D 5e ao vivo antes, na documentação',
  'landing.seg.zero.make': 'Faça a sua',
  'landing.seg.zero.makeText': 'Estas linhas são uma ficha que funciona. Mude o nome ou a Força e role.',
  'landing.seg.zero.code': 'ficha.html',
  'landing.seg.zero.result': 'A ficha, ao vivo',
  'landing.seg.zero.demo.name': 'Nome',
  'landing.seg.zero.demo.nameField': 'nome',
  'landing.seg.zero.demo.strength': 'Força',
  'landing.seg.zero.demo.strengthField': 'forca',
  'landing.seg.zero.demo.roll': 'Rolar Força',
  'landing.seg.zero.demo.label': 'Teste de Força de {name}',
  'landing.seg.zero.demo.sample': 'Aria',
  'landing.seg.zero.demo.empty': 'A rolagem aparece aqui, como no chat da mesa.',
  'landing.seg.prep.time': '19:40',
  'landing.seg.prep.label': 'Preparo',
  'landing.seg.prep.title': 'O mestre monta a cena antes de todo mundo chegar.',
  'landing.seg.prep.text': 'O mapa com a grade, os tokens, as paredes e as portas, a névoa por cima e os arquivos da campanha à mão no Desk Cloud.',
  'landing.seg.prep.items': 'Grade e tokens — A grade detectada no próprio mapa e os tokens arrastados do computador\nNévoa de guerra — O mestre revela as áreas com o mouse\nVisão e luz — Por token, com visão no escuro e a área já explorada\nParedes e portas — Janelas e portas, até trancadas e secretas\nMapas UVTT — Do Dungeondraft, chegam com paredes, portas e luzes\nDesk Cloud — "Usar na mesa" leva o arquivo com um clique, e "Quem pode abrir" evita spoiler',
  'landing.seg.prep.camera': 'Câmera do mestre · ferramenta Paredes',
  'landing.seg.prep.pip': 'Desk Cloud',
  'landing.seg.arrive.time': '20:00',
  'landing.seg.arrive.label': 'O grupo chega',
  'landing.seg.arrive.title': 'O grupo chega pelo link. A voz já está na mesa.',
  'landing.seg.arrive.text': 'Quem tem o convite entra direto na mesa, pelo computador ou pelo celular. Quem ainda não tem grupo procura uma mesa em Salas.',
  'landing.seg.arrive.items': 'Convite — Por link, com senha e boas-vindas se o mestre quiser\nVoz e vídeo — Na própria mesa, com a câmera no cartão de cada um\nSalas — As mesas públicas, com filtros por sistema, língua, frequência e visual\nCelular — A mesa vira abas: Chat, Cena, Fichas, Pessoas e Mais\nAmigos — Status e mensagens diretas em qualquer tela',
  'landing.seg.arrive.cta': 'Criar conta para jogar',
  'landing.seg.arrive.events': 'Luana entrou pelo link\nDavi ligou o microfone\nTeo entrou como espectador\nMarina abriu a cena',
  'landing.seg.arrive.camera': 'Salas · procurar uma mesa',
  'landing.seg.arrive.phone': 'No celular',
  'landing.seg.combat.time': '20:30',
  'landing.seg.combat.label': 'Combate',
  'landing.seg.combat.title': 'Os dados caem na tela de todos ao mesmo tempo.',
  'landing.seg.combat.text': 'A rolagem é feita no servidor, e ninguém escolhe o resultado. A ficha rola pelos botões, o tracker avisa a vez no chat e a trilha toca para todos.',
  'landing.seg.combat.items': 'Rolagens — /r 1d20+5, dados rápidos de d4 a d100, sucessos e Fudge\nDados 3D — Com as suas cores e efeitos como Fogo, Gelo e Raio\nFichas — Gravam enquanto você digita, com as partes só do mestre\nTracker — Iniciativa, turnos e efeitos com duração\nMúsica — Trilha e efeitos sonoros tocando para todos ao mesmo tempo\nMacros — Os seus comandos numa palavra, como /ataque',
  'landing.seg.combat.music': 'Tocando para todos: Combate',
  'landing.seg.combat.camera': 'Dados 3D sobre a mesa',
  'landing.seg.combat.sheet': 'Ficha da Aria',
  'landing.seg.diary.time': '23:00',
  'landing.seg.diary.label': 'Diário',
  'landing.seg.diary.title': 'O relógio para, e o diário guarda a noite.',
  'landing.seg.diary.text': 'O relógio da sessão marca o tempo de jogo de todos, e cada sessão fica registrada, com título, notas e quem estava. Na semana que vem, a mesa está lá, do jeito que vocês deixaram.',
  'landing.seg.diary.items': 'Relógio — O tempo de jogo para todos, com pausa\nRegistro — Cada sessão com título, notas e quem estava\nInício — Leva de volta às suas mesas, onde vocês pararam\nA mesa fica — Fichas, cenas e arquivos continuam na mesa e no Desk Cloud',
  'landing.seg.diary.board': 'Sessão encerrada',
  'landing.seg.diary.played': '{time} de jogo',
  'landing.seg.diary.ended': 'Sessão encerrada às 23:12',
  'landing.seg.diary.next': 'Próxima sessão: semana que vem, mesma hora',
  'landing.docsLinks': 'Na documentação',
  'landing.credits.title': 'Ficha técnica',
  'landing.credits.text': 'Tudo o que vem na mesa. Nada escondido: cada recurso tem a sua página na documentação.',
  'landing.alt.ficha-dnd5e': 'A ficha D&D 5e de Aria Folhaverde, patrulheira meio-elfa de nível 3: o nome na faixa, classe, antecedente e raça, os seis atributos com os modificadores e as perícias, a CA 15, o deslocamento de 9 m e os pontos de vida 24 de 28.',
  'landing.alt.combate-tracker': 'O tracker de combate: o Próx. turno, os botões de jogadores, rolar e limpar, e a iniciativa com a vez de Aria (17), o Esqueleto (14, hostil) e Bram (12).',
  'landing.alt.cena-paredes': 'A ferramenta Paredes: a barra de opções com Desenhar, Selecionar, Remover com retângulo, os tipos de parede e as formas, e as paredes do salão em vermelho com uma porta amarela na parede leste.',
  'landing.alt.arquivos': 'O Desk Cloud: à esquerda as visões, as mesas, as pastas e o espaço por tipo; no meio as pastas e os arquivos em cartões, com o tipo e as mesas de cada um; à direita os detalhes de um mapa, com Usar na mesa e Quem pode abrir.',
  'landing.alt.explorar': 'O Explorar na lista Com gente agora: a coluna de filtros à esquerda e, à direita, cartões de mesa com capa, sistema, quem está na mesa e selos como Procura jogadores.',
  'landing.alt.celular-inicio': 'O Início no celular: a última mesa em destaque, com a capa em cima, os botões Criar sala e Explorar, a faixa com a mesa aberta e a barra de baixo com Início, Salas, Amigos, Arquivos e Mais.',
  'landing.alt.dados-3d': 'Os dados 3D das últimas rolagens rolando por cima da mesa, sobre a biblioteca e o chat.',
  'landing.alt.ficha': 'A ficha de Aria aberta numa aba da mesa: retrato, nome, origem, classe, vida e energia, defesa, deslocamento e a lista de atributos com os botões de rolar.',
  'landing.alt.map': 'O mapa da cripta visto de cima: o salão com quatro colunas e tochas acesas, uma sala com um altar, um depósito com caixotes e a câmara do sarcófago, com os tokens de Aria e Bram e um esqueleto.',
  'landing.alt.sessoes': 'A aba Sessões: a sessão em jogo, com o relógio, os botões de pausar e encerrar e quem está na sessão; embaixo, as sessões anteriores, O guardião da porta e A descida à cripta, com o dia e o tempo de jogo.',
  'landing.alt.voz-conferencia': 'O painel da conferência com duas pessoas, Marina e Luana, e os botões de microfone, câmera e sair.',
  'landing.features.group.table': 'A mesa',
  'landing.features.group.scene': 'Cena e mapa',
  'landing.features.group.sheets': 'Fichas e plugins',
  'landing.features.group.gm': 'Para quem mestra',
  'landing.features.group.group': 'O grupo',
  'landing.features.group.where': 'Arquivos e onde jogar',
  'landing.feature.layout.title': 'Abas e espaços',
  'landing.feature.layout.text': 'Arrume a mesa como quiser: arraste, divida e junte as abas.',
  'landing.feature.chat.title': 'Chat',
  'landing.feature.chat.text': 'Narração, falas de NPC, ações, formatação, emoji, menções e anexos.',
  'landing.feature.dice.title': 'Rolagens',
  'landing.feature.dice.text': 'Expressões, dados rápidos, sucessos, Fudge e dados 3D para todos.',
  'landing.feature.library.title': 'Biblioteca',
  'landing.feature.library.text': 'Fichas, cenas e pastas que nascem ocultas até o mestre liberar.',
  'landing.feature.participants.title': 'Participantes',
  'landing.feature.participants.text': 'Mestres, jogadores e espectadores, com foto e barras no cartão.',
  'landing.feature.macros.title': 'Macros',
  'landing.feature.macros.text': 'Os seus comandos numa palavra, e uma tabela de botões.',
  'landing.feature.scene.title': 'Montar a cena',
  'landing.feature.scene.text': 'Mapa com a grade detectada, escala e tokens arrastados do computador.',
  'landing.feature.playerScene.title': 'A cena do jogador',
  'landing.feature.playerScene.text': 'Mover com caminho e distância, régua, ping, desenhos e portas.',
  'landing.feature.fog.title': 'Névoa de guerra',
  'landing.feature.fog.text': 'Tudo começa coberto, e o mestre revela as áreas.',
  'landing.feature.vision.title': 'Visão e luz',
  'landing.feature.vision.text': 'Cada um vê o que os seus tokens enxergam, e o mestre tem o "Ver como".',
  'landing.feature.walls.title': 'Paredes e portas',
  'landing.feature.walls.text': 'Parede, janela, terreno, porta trancada e porta secreta.',
  'landing.feature.uvtt.title': 'Importar mapas',
  'landing.feature.uvtt.text': 'Mapas UVTT do Dungeondraft, com paredes, portas e luzes.',
  'landing.feature.tokens.title': 'Condições e auras',
  'landing.feature.tokens.text': 'Ícones de condição, auras que giram com o token e o token invisível.',
  'landing.feature.sheets.title': 'Fichas ao vivo',
  'landing.feature.sheets.text': 'Gravam enquanto você digita, e os botões rolam no chat.',
  'landing.feature.gmParts.title': 'Fichas dos jogadores',
  'landing.feature.gmParts.text': 'O mestre cria e entrega, e as partes dele nem chegam aos jogadores.',
  'landing.feature.create.title': 'Crie suas fichas',
  'landing.feature.create.text': 'Uma ficha é uma página web: HTML, CSS e, se quiser, JavaScript.',
  'landing.feature.ai.title': 'Fichas com IA',
  'landing.feature.ai.text': 'Copie o guia pelo botão da página Plugins, descreva a ficha e instale o arquivo.',
  'landing.feature.languages.title': 'Duas línguas',
  'landing.feature.languages.text': 'A mesma ficha em português e em inglês, com a tradução ao lado do texto.',
  'landing.feature.examples.title': 'Exemplos prontos',
  'landing.feature.examples.text': 'Fichas e tabelas para usar ou adaptar, ao vivo e para baixar.',
  'landing.feature.tables.title': 'Tabelas da mesa',
  'landing.feature.tables.text': 'Páginas para a mesa toda, como NPCs e calendário, com partes ocultas.',
  'landing.feature.plugins.title': 'Plugins da mesa',
  'landing.feature.plugins.text': 'Os oficiais com um clique, ou um arquivo do Desk Cloud ou do computador; o verificador explica o que consertar.',
  'landing.feature.integrations.title': 'Integrações',
  'landing.feature.integrations.text': 'Webhooks para o Discord, planilhas e luzes, pelo Zapier, Make ou IFTTT.',
  'landing.feature.combat.title': 'Tracker de combate',
  'landing.feature.combat.text': 'Iniciativa, turnos, rodadas, lados e efeitos com duração.',
  'landing.feature.clock.title': 'Relógio da sessão',
  'landing.feature.clock.text': 'O tempo de jogo para todos e um diário de cada sessão.',
  'landing.feature.music.title': 'Música e efeitos',
  'landing.feature.music.text': 'Playlist sincronizada e um quadro de efeitos sonoros.',
  'landing.feature.roles.title': 'Papéis e moderação',
  'landing.feature.roles.text': 'Silenciar, chat moderado, apagar mensagens, expulsar e banir.',
  'landing.feature.rules.title': 'Regras de jogo',
  'landing.feature.rules.text': 'Barras e linhas nos cartões, com os números para quem você quiser.',
  'landing.feature.roomSettings.title': 'Configurar a mesa',
  'landing.feature.roomSettings.text': 'Capa, marca, senha, histórico do chat e mestres auxiliares.',
  'landing.feature.voice.title': 'Voz e vídeo',
  'landing.feature.voice.text': 'Conferência na mesa, com a webcam no cartão de cada um.',
  'landing.feature.friends.title': 'Amigos',
  'landing.feature.friends.text': 'Perfil, status, mensagens diretas e convites para a mesa.',
  'landing.feature.explore.title': 'Explorar',
  'landing.feature.explore.text': 'Mesas públicas, filtros e as que procuram jogadores.',
  'landing.feature.invite.title': 'Criar e convidar',
  'landing.feature.invite.text': 'Sistema, boas-vindas, senha e o link de convite.',
  'landing.feature.windows.title': 'Janelas próprias',
  'landing.feature.windows.text': 'Leve abas para outro monitor, com até 8 mesas abertas.',
  'landing.feature.home.title': 'Início',
  'landing.feature.home.text': 'Continue de onde parou, com as suas mesas e os sistemas mais jogados.',
  'landing.feature.cloud.title': 'Desk Cloud',
  'landing.feature.cloud.text': 'Mapas, tokens, áudio e documentos em pastas, prontos para usar na mesa.',
  'landing.feature.browser.title': 'No navegador',
  'landing.feature.browser.text': 'Chrome, Edge, Firefox ou Opera, sem instalar nada.',
  'landing.feature.mobile.title': 'No celular',
  'landing.feature.mobile.text': 'Abas feitas para o dedo, e instala como aplicativo.',
  'landing.feature.desktop.title': 'App para Windows',
  'landing.feature.desktop.text': 'A mesma mesa num aplicativo para o computador.',
  'landing.plans.text': 'Mesas, fichas, cena, dados, voz e vídeo, chat, plugins e amigos são iguais em todos os planos. Os planos pagos só aumentam o espaço do Desk Cloud e o tamanho dos arquivos.',
  'landing.plans.notice': 'Os planos pagos ainda não estão disponíveis. Por enquanto, todo mundo joga no Grátis.',
  'landing.plans.available': 'Disponível',
  'landing.plans.soon': 'Em breve',
  'landing.plans.more': 'Como funcionam os planos',
  'landing.plans.title': 'Grátis. Tudo.',
  'landing.end.title': 'Semana que vem, mesma hora. A mesa é sua.',
  'landing.end.text': 'Crie a conta, monte a primeira mesa e mande o link para o grupo.',
  'landing.end.signIn': 'Já tenho conta: entrar',
  'landing.footer.help': 'Ajuda',
};
